import React from "react";
import { withRouter, useHistory } from "react-router-dom";
import DetailSanzioneService from "./detailSanzioneService";
import LoadSpinner from "../../../common/spinner/loadSpinner";
import { BsFillHouseDoorFill } from "react-icons/bs";
import moment from "moment";
import NumberFormat from "react-number-format";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import detailCss from "../../../css/detailSanzione/detailSanzione.css";
import Menucustom from "../../../common/menu/menucustom";
import { Modal, Button, Row, Col, Form, Table } from "react-bootstrap";
import { calculateTimeDifferenceTwoDates } from "../../../common/utils";
import {
  validEmail,
  validPassword,
  capitalizeFirstLetter,
  validCF,
  validDate,
  geDataFormat,getDataFormatWithTime,getFormatOraInputFirst,getFormatOraInputFirstaddMont,geDataFormatFirst,getFormatOraInput
} from "../../../common/utils";
import { findAllByDisplayValue } from "@testing-library/react";
import { data, error } from "jquery";
import { toast } from "react-toastify";
import GestioneAllegati from "../../../common/mookup/GestioneAllegati.json";
import e from "cors";
import R from "./letter-r.png";
class DetailSanzione extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      impostazioniSpese: [],
      showModalSanzioniRecidivo: false,
      buttonRecidivi: true,
      idStatoPassagio: 0,
      agliAttiScrittoDifensivo: true,
      showModalAgliAttiScrittoDifensivo: false,
      showModalScrittoDifensivoToValidata: false,
      // errorDataDiRilascioTrasgessorePatria: false,
      // errorDataDiRilascioTrasgessore: false,
      // errorDataDiNascitaTrasgessorePatria: false,
      // errorDataDiNascitaTrasgessore: false,
      errorCFTrasgessorePatria: false,
      errorCFTrasgessore: false,
      messaggioList: [],
      importoDasalvareIDRata: "",
      modalShowattoIngiuntivo:false,
      buttonValidaSanzione: true,
      buttonConfermaValidaznione: true,
      scrittoDifensivoAllegatoBase64: "",
      allegatiSanzioneAggiungiBase64: "",
      showModalTentativiPagamento: false,
      showModalConfermaAnnullaTentativoPagamento: false,
      tentativoPagamentoDaAnnullare: {id:0,dataTentativo:0},
      showModalGestioneAllegati: false,
      showModalConfermaEliminaAllegato: false,
      AggiungiAllegato: false,
      showModalBolletinoPostale: false,
      disableInput: true,
      buttonAltriStati: true,
      fileBase64: "",
      loading: true,
      buttonVerbaleFattoAbbordo: true,
      statosingoloImporto: [],
      importoDaSalvarestate: [],
      isErrorEmail: true,
      showModalModificaSanzione: false,
      showModalAvanzaStato: false,
      showModalChiudiSanzione: false,
      showModalInvioMail: false,
      showModalStoricoSanzione: false,
      showModalPaga: false,
      showModalScrittoDifensivo: false,
      buttonScrittoDifensivo: true,
      showModalRavvedimentoOperoso: false,
      isNotaRavvedimentoOperoso: true,
      showModalSbloccaSanzione: false,
      nuovoImportoRavvedimentoOperoso: "",
      notaRavvedimentoOperoso: "",
      fieldIndirizzoMail: "",
      noteAltriStati: "",
      selectAltriStati: 0,
      statiSanzione: [],
      listaSpacchettatiIntero:[],
      listaSpacchettatiRidotto:[],
      speseProcedimento: 0,
      valoreProv: 0,
      tableRata: [],
      isRata: false,
      showModalRateDaPagare: false,
      testoModificaSanzione: "Abilita Modifiche",
      showModalRateizzaSanzione: false,
      rateizzaButton: true,
      resetRateizzaButton: true,
      pathPush: "",
      path: "",
      showModalStoricoPagamenti:false,
      storicoPagamenti:[
      ],
      errorNumeroRata: false,
      calcolaRata: true,
      statoSingolaRata: "",
      sommaDiTuttiGliImportiRata: 0,
      giorniAllaScadenza: 0,
      isReduced5Days: false,
      isReduced60Days: false,
      confermaUlteriorreDiunPagamento: true,
      bloccoTastiAlconfermaPagamento: false,
      importoInferiroDellaSanzioneDiUnPagamento: true,
      noteAgliAtti: "",
      seIlPagamentoDerivaDaUnaRata: false,
      importoRataInferioreAImportoRata: 0,
      rowSanzionePrev: {
        idSaznioneProvenienza: 0,
        numeroSanzioneProvenienza: "",
      },
      validaInidirizzo: {
        capResponse: "",
        provinciaResponse: "",
        viaResponse: "",
        numeroResponse: "",
        comuneResponse: "",
        esito: "",
        messaggio: "",
      },
      tentativiPagamento: [
        {
          id: 0,
          dataTentativo: 0,
          esito: "",
          importo: 0,
        },
      ],
      allegatiSanzione: [
        {
          id: 0,
          nomeFile: 0,
          file: "",
          data: "",
        },
      ],
      paga: {
        numeroSanzione: "",
        dataContabile: getFormatOraInput(new Date()),
        tipoPagamento: "0",
        importoNetto: 0,
        codiceTx: "",
        note: "",
        numeroRata: "",
      },
      creaRata: {
        numeroDiRata: 0,
        SpeseIncassoRata: "",
      },
      rata: {
        numeroSanzione: "",
        scaduta:false,
        rate: [
          {
            id: 0,
            numeroRata: "",
            importo: "",
            dataScandenza: "",
            stato: "",
            spesaIncassoRata: "",
          },
        ],
      },
      scrittoDifensivo: {
        allegato: "",
        DescrizioneScrittoDifensivo: "",
      },
      sanzione: {
        numeroSanzione: "",
        idSanzione: "",
        matricolaControllore: "",
        dataDiEmissione: "",
        importo: "",
        anagraficaTrasgressore: {
          nome: "",
          cognome: "",
          dataDiNascita: "",
          luogoDiNascita: "",
          isMinorenne: false,
          numeroDocumento: "",
          tipoDocumento:"",
          dataRilascioDocumento: "",
          comuneDiResidenza: "",
          inidirizzoDiResidenza: "",
          inidirizzoNumeroDiResidenza: "",
          frazione: "",
          provinciaDiResidenza: "",
          capDiResidenza: "",
          codiceFiscale: "",
          sesso: ""
        },
        anagraficaPotestaTrasgressore: {
          nome: "",
          cognome: "",
          dataDiNascita: "",
          luogoDiNascita: "",
          isMinorenne: false,
          numeroDocumento: "",
          tipoDocumento:"",
          dataRilascioDocumento: "",
          comuneDiResidenza: "",
          inidirizzoDiResidenza: "",
          inidirizzoNumeroDiResidenza: "",
          frazione: "",
          provinciaDiResidenza: "",
          capDiResidenza: "",
          codiceFiscale: "",
          sesso: ""
        },
        anagraficaTipologiaSanzione: {
          nomeViolazione: "",
          speseProcedura: 0,
          idAnagrafiaTipolagiaSanzione: 0,
          importoRidotto: 0,
          aggiungiPrezzoTratta: 0,
        },
        anagraficaStati: {
          nomeStato: "",
        },
        // tratta:{
        //     origine:'',
        //     destinazione:'',
        //     prezzo:''
        // },
        violazione: "",
        isverbaleFattoABordo: false,
        noteTrasgressore: "",
        annotazioneControllore: "",
      },
      sexList: [
        "M",
        "F"
      ],
      listaStatiTo: [
        {
          idStato: 0,
          nomeStato: "",
        },
      ],
      recidivo: [
        {
          nome: "",
          cognome: "",
          cf: "",
          nSanz: 0,
          listaDiDettaglioSanzioni: [
            {
              numSanzione: "",
              dataEmissione: 0,
              statoSanzione: "",
              idSanzione: 0,
            },
          ],
        },
      ],
      allegatoDaEliminare:{
        id:"",
        nome:""
      },
      loadingAllegato:false,
      loadingButton:false,
      sanctionEmissionDate: 0,
    };
    this.backHome = this.backHome.bind(this);
    this.nameRegex = new RegExp("^[A-Za-zÀ-ÖØ-öø-ÿ']{2,}(?: [A-Za-zÀ-ÖØ-öø-ÿ']+)*$");
    this.ravvedimentoOperosoValueRegex = new RegExp("^[0-9]+(\\,[0-9]+)?$");
  }

  componentDidMount() {
    this.gestioneFile =
      "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";
    this.detailSanzioneService = new DetailSanzioneService();

    this.detailSanzioneService.impostazioniSpese((result) => {
      // console.log(result);
      this.state.impostazioniSpese = result;
    });

    var rowSanzione = JSON.parse(sessionStorage.getItem("rowSanzione"));
    // if(rowSanzione.statoSanzione === "Pagata") {
    //   this.detailSanzioneService.getStoricoPagamenti(rowSanzione.id,
    //     (result)=>{
    //       if(result){
    //         this.setState({storicoPagamenti:[...result]})
    //       }
    //     },
    //     (error)=>{
    //       toast.error("Errore nel caricare lo storico pagamenti, Riprova")
    //       this.setState({storicoPagamenti:[]})
    //     })
    // }
    
    //verificare l'id della sanzione per le ingiunzioni
    this.detailSanzioneService.getDetailSanzione(
      rowSanzione.id,
      this.onSuccessGetDetailSanzione.bind(this)
    );

    // console.log(this.storia)
    //  console.log(document.referrer)
    var search = this.props.location.search;
    var stato = "daLav";
    if (search != null && search.includes("?")) {
      stato = search.substring(1, search.lenght);
    }

    this.detailSanzioneService.getIsRata((result) => {
      this.setState({ isRata: result.isRata });
      // console.log(result);
    });

    // this.detailSanzioneService.getDetailRata(rowSanzione.id, (result) => {
    //   this.state.rata = result.data;
    // });

    // var statoDiLavorazione = this.state.sanzione.anagraficaStati.nomeStato;
    // if (rowSanzione.payroll === true) {
    //   this.state.path = "Payroll";
    //   this.state.pathPush = "#/Payroll";
    // }
    if (rowSanzione.recidivo === true) {
      this.state.path = "Recidivi";
      this.state.pathPush = "#/recidivi";
    }
    if (rowSanzione.mappatura === true) {
      this.state.path = "Dashboard Mappature";
      this.state.pathPush = "#/dashboardMappature";
    } else {
      this.state.path =
        rowSanzione.statoSanzione === "Caricato"
          ? "Da Lavorare"
          : rowSanzione.statoSanzione === "Validato"
          ? "In Lavorazione"
          : rowSanzione.statoSanzione === "Pagata"
          ? "Pagate"
          : rowSanzione.statoSanzione === "Poste Inviato File"
          ? "Postalizzate"
          : rowSanzione.statoSanzione === "Ravvedimento Operoso"
          ? "Ravvedimento Operoso"
          : rowSanzione.statoSanzione === "Agli Atti"
          ? "Agli Atti"
          : rowSanzione.statoSanzione === "Annullata"
          ? "Annullate"
          : rowSanzione.statoSanzione === "Scritto Difensivo"
          ? "Altri"
          : rowSanzione.statoSanzione === "Bloccata"
          ? "Altri"
          : rowSanzione.statoSanzione === "Scaduta"
          ? "Altri"
          : rowSanzione.statoSanzione === "In Attesa"
          ? "In Lavorazione"
          : rowSanzione.statoSanzione === "Rateizzato"
          ? "Rateizzato"
          : rowSanzione.statoSanzione === "In Attesa Ricevuta"
          ? "In Lavorazione"
          : rowSanzione.statoSanzione === "Ingiunzione"
          ? "Ingiunzioni"
          : rowSanzione.statoSanzione === "Recidivo"
          ? "Recidivo"
          : rowSanzione.statoSanzione === "IngiunzioneAperta"
          ? "Ingiunzione Aperta"
          : rowSanzione.statoSanzione === "IngiunzionePostalizzata"
          ? "Ingiunzione Postalizzata"
          : rowSanzione.statoSanzione === "IngiunzioneChiusa"
          ? "Ingiunzione Chiusa"
          : rowSanzione.statoSanzione === "IngiunzionePagata"
          ? "Ingiunzione Chiusa"
          : rowSanzione.statoSanzione === "RecuperoCrediti"
          ? "Recupero Crediti"
          : rowSanzione.statoSanzione === "RicercaRapida"
          ? "Ricerca Rapida"
          : rowSanzione.payroll === true
          ? "Payroll"
          : "";

      this.state.pathPush =
        rowSanzione.statoSanzione === "Caricato"
          ? "#/home?daLav"
          : rowSanzione.statoSanzione === "Validato"
          ? "#/home?inLav"
          : rowSanzione.statoSanzione === "Pagata"
          ? "#/home?pagate"
          : rowSanzione.statoSanzione === "Poste Inviato File"
          ? "#/home?postalizzate"
          : rowSanzione.statoSanzione === "Ravvedimento Operoso"
          ? "#/home?ravvedimentoOperoso"
          : rowSanzione.statoSanzione === "Agli Atti"
          ? "#/home?agliAtti"
          : rowSanzione.statoSanzione === "Annullata"
          ? "#/home?annullate"
          : rowSanzione.statoSanzione === "Scritto Difensivo"
          ? "#/home?altri"
          : rowSanzione.statoSanzione === "Bloccata"
          ? "#/home?altri"
          : rowSanzione.statoSanzione === "Scaduta"
          ? "#/home?altri"
          : rowSanzione.statoSanzione === "Rateizzato"
          ? "#/home?rateizzati"
          : rowSanzione.statoSanzione === "Ingiunzione"
          ? "#/ingiunzioni"
          : rowSanzione.statoSanzione === "Recidivo"
          ? "#/recidivi"
          : rowSanzione.statoSanzione === "IngiunzioneAperta"
          ? "#/ingiunzioni?aperte"
          : rowSanzione.statoSanzione === "IngiunzionePostalizzata"
          ? "#/ingiunzioni?postalizzate"
          : rowSanzione.statoSanzione === "IngiunzioneChiusa"
          ? "#/ingiunzioni?chiuse"
          : rowSanzione.statoSanzione === "IngiunzionePagata"
          ? "#/ingiunzioni?pagate"
          : rowSanzione.statoSanzione === "RecuperoCrediti"
          ? "#/RecuperoCrediti"
          : rowSanzione.statoSanzione === "RicercaRapida"
          ? "#/RicercaRapida"
          : rowSanzione.payroll === true
          ? "#/Payroll"
          : "";
    }
  }

  findIndexFromSexList(sex) {
    if(sex == null) return null
    let index = this.state.sexList.findIndex((value) => value === sex)
    return index > -1 ? index : null
  }

  showModalConfermaAnnullaTentativoPagamentoHandler(dati){
    if(this.state.showModalConfermaAnnullaTentativoPagamento){
      this.setState({showModalConfermaAnnullaTentativoPagamento:false});
      this.setState({tentativoPagamentoDaAnnullare:{id:0,dataTentativo:0}});
    }else{
      if(dati !== null){
      this.setState({tentativoPagamentoDaAnnullare:dati});
      this.setState({showModalConfermaAnnullaTentativoPagamento:true});
      }
    }
  }

  showModalConfermaEliminaAllegatoHandler(dati){
    if(this.state.showModalConfermaEliminaAllegato){
      this.setState({showModalConfermaEliminaAllegato:false});
      this.setState({allegatoDaEliminare:{id:"",nome:""}});
    }else{
      if(dati !== null){
      this.setState({allegatoDaEliminare:dati});
      this.setState({showModalConfermaEliminaAllegato:true});
      }
    }
  }

  onsuccessModificaSanzione(row) {
    // window.location.reload();
    // console.log(row);
    this.setState({
      loadingButton:false,
      showModalModificaSanzione:false,
    })
    if(row.includes("correttamente")){
      toast.success(row);
    }else{
      toast.error(row);
    }
    var rowSanzione = JSON.parse(sessionStorage.getItem("rowSanzione"));
    this.detailSanzioneService.getDetailSanzione(
      rowSanzione.id,
      this.onSuccessGetDetailSanzione.bind(this)
    );
    this.setState({ loading: false });
  }

  modificaSanzione() {
    this.setState({ showModalModificaSanzione: true });
  }

  confermaModificaSanzione() {
    this.setState({ buttonVerbaleFattoAbbordo: true });

    // if (this.state.sanzione.anagraficaTrasgressore.dataDiNascita) {
    //   if (
    //     this.state.sanzione.anagraficaTrasgressore.dataDiNascita
    //       .toString()
    //       .includes("/")
    //   ) {
    //     const dataNascitaSaznionato =
    //       this.state.sanzione.anagraficaTrasgressore.dataDiNascita.split("/");

    //     this.state.sanzione.anagraficaTrasgressore.dataDiNascita = new Date(
    //       +dataNascitaSaznionato[2],
    //       dataNascitaSaznionato[1] - 1,
    //       +dataNascitaSaznionato[0]
    //     );
    //   }
    // }
    // if (this.state.sanzione.anagraficaPotestaTrasgressore.dataDiNascita) {
    //   if (
    //     this.state.sanzione.anagraficaPotestaTrasgressore.dataDiNascita
    //       .toString()
    //       .includes("/")
    //   ) {
    //     const dataNascitaSaznionatoPotesta =
    //       this.state.sanzione.anagraficaPotestaTrasgressore.dataDiNascita.split(
    //         "/"
    //       );
    //     this.state.sanzione.anagraficaPotestaTrasgressore.dataDiNascita =
    //       new Date(
    //         +dataNascitaSaznionatoPotesta[2],
    //         dataNascitaSaznionatoPotesta[1] - 1,
    //         +dataNascitaSaznionatoPotesta[0]
    //       );
    //   }
    // }
    this.state.sanzione.anagraficaTrasgressore.dataDiNascita = new Date(this.state.sanzione.anagraficaTrasgressore.dataDiNascita);
    this.state.sanzione.anagraficaTrasgressore.dataRilascioDocumento = new Date(this.state.sanzione.anagraficaTrasgressore.dataRilascioDocumento);
    this.state.sanzione.anagraficaPotestaTrasgressore.dataDiNascita = new Date(this.state.sanzione.anagraficaPotestaTrasgressore.dataDiNascita);
    this.state.sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento = new Date(this.state.sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento);
    // if (this.state.sanzione.anagraficaTrasgressore.dataRilascioDocumento) {
    //   if (
    //     this.state.sanzione.anagraficaTrasgressore.dataRilascioDocumento
    //       .toString()
    //       .includes("/")
    //   ) {
    //     const dataRilascioSanzionato =
    //       this.state.sanzione.anagraficaTrasgressore.dataRilascioDocumento.split(
    //         "/"
    //       );
    //     this.state.sanzione.anagraficaTrasgressore.dataRilascioDocumento =
    //       new Date(
    //         +dataRilascioSanzionato[2],
    //         dataRilascioSanzionato[1] - 1,
    //         +dataRilascioSanzionato[0]
    //       );
    //   }
    // }

    // if (
    //   this.state.sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento
    // ) {
    //   if (
    //     this.state.sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento
    //       .toString()
    //       .includes("/")
    //   ) {
    //     const dataRilascioSanzionatoPotesta =
    //       this.state.sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento.split(
    //         "/"
    //       );
    //     this.state.sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento =
    //       new Date(
    //         +dataRilascioSanzionatoPotesta[2],
    //         dataRilascioSanzionatoPotesta[1] - 1,
    //         +dataRilascioSanzionatoPotesta[0]
    //       );
    //   }
    // }
    this.setState({loadingButton:true})
    this.detailSanzioneService.saveSanzione(
      this.state.sanzione,
      this.onsuccessModificaSanzione.bind(this)
    );

    this.setState((prevState) => ({
      disableInput: !prevState.disableInput,
    }));

    if (this.state.testoModificaSanzione === "Abilita Modifiche") {
      this.setState({
        testoModificaSanzione: "Disabilita Modifiche",
        errorCFTrasgessore: false,
        errorCFTrasgessorePatria: false,
        errorDataDiNascitaTrasgessore: false,
        errorDataDiNascitaTrasgessorePatria: false,
        errorDataDiRilascioTrasgessore: false,
        errorDataDiRilascioTrasgessorePatria: false,
        buttonVerbaleFattoAbbordo: false,
        buttonValidaSanzione: false,
      });
      // this.setState({})
    } else {
      var rowSanzione = JSON.parse(sessionStorage.getItem("rowSanzione"));
      this.detailSanzioneService.getDetailSanzione(
        rowSanzione.id,
        this.onSuccessGetDetailSanzione.bind(this)
      );
      this.setState({
        testoModificaSanzione: "Abilita Modifiche",
        buttonVerbaleFattoAbbordo: true,
      });
      // this.setState({})
    }
    //this.setState({ showModalModificaSanzione: false });
  }
  annullaModificaSanzione() {
    this.setState({ showModalModificaSanzione: false });
  }

  cambioStato(event) {
    this.superFraseDaCambiare =
      "I nostri sistemi hanno trovato questo indirizzo, vuoi validare la sanzione?";
    this.state.idStatoPassagio = parseInt(event.target.id);
    if (this.state.sanzione.anagraficaTrasgressore.isMinorenne === false) {
      this.detailSanzioneService.validaIndirizzo(
        this.state.sanzione.anagraficaTrasgressore.inidirizzoDiResidenza,
        this.state.sanzione.anagraficaTrasgressore.comuneDiResidenza,
        this.state.sanzione.anagraficaTrasgressore.provinciaDiResidenza,
        this.state.sanzione.anagraficaTrasgressore.capDiResidenza,
        this.state.sanzione.anagraficaTrasgressore.inidirizzoNumeroDiResidenza,
        (result) => {
          // console.log(result.data);
          const frasi = result.data.messaggio.split(";");
          this.setState({
            validaInidirizzo: result.data,
            messaggioList: frasi,
          });
        }
      );
    } else {
      this.detailSanzioneService.validaIndirizzo(
        this.state.sanzione.anagraficaPotestaTrasgressore.inidirizzoDiResidenza,
        this.state.sanzione.anagraficaPotestaTrasgressore.comuneDiResidenza,
        this.state.sanzione.anagraficaPotestaTrasgressore.provinciaDiResidenza,
        this.state.sanzione.anagraficaPotestaTrasgressore.capDiResidenza,
        this.state.sanzione.anagraficaPotestaTrasgressore
          .inidirizzoNumeroDiResidenza,
        (result) => {
          // console.log(result.data);
          const frasi = result.data.messaggio.split(";");
          this.setState({
            validaInidirizzo: result.data,
            messaggioList: frasi,
          });
        }
      );
    }

    const frasi = this.state.validaInidirizzo.messaggio.split(";");

    this.setState({ showModalAvanzaStato: true, messaggioList: frasi });
  }

  modalScrittoToValidataShowHandler(event) {
    this.superFraseDaCambiare =
      "I nostri sistemi hanno trovato questo indirizzo, vuoi validare la sanzione?";
    this.state.idStatoPassagio = parseInt(event.target.id);
    if (this.state.sanzione.anagraficaTrasgressore.isMinorenne === false) {
      this.detailSanzioneService.validaIndirizzo(
        this.state.sanzione.anagraficaTrasgressore.inidirizzoDiResidenza,
        this.state.sanzione.anagraficaTrasgressore.comuneDiResidenza,
        this.state.sanzione.anagraficaTrasgressore.provinciaDiResidenza,
        this.state.sanzione.anagraficaTrasgressore.capDiResidenza,
        this.state.sanzione.anagraficaTrasgressore.inidirizzoNumeroDiResidenza,
        (result) => {
          // console.log(result.data);
          const frasi = result.data.messaggio.split(";");
          this.setState({
            validaInidirizzo: result.data,
            messaggioList: frasi,
          });
        }
      );
    } else {
      this.detailSanzioneService.validaIndirizzo(
        this.state.sanzione.anagraficaPotestaTrasgressore.inidirizzoDiResidenza,
        this.state.sanzione.anagraficaPotestaTrasgressore.comuneDiResidenza,
        this.state.sanzione.anagraficaPotestaTrasgressore.provinciaDiResidenza,
        this.state.sanzione.anagraficaPotestaTrasgressore.capDiResidenza,
        this.state.sanzione.anagraficaPotestaTrasgressore
          .inidirizzoNumeroDiResidenza,
        (result) => {
          // console.log(result.data);
          const frasi = result.data.messaggio.split(";");
          this.setState({
            validaInidirizzo: result.data,
            messaggioList: frasi,
          });
        }
      );
    }

    const frasi = this.state.validaInidirizzo.messaggio.split(";");

    this.setState({ showModalScrittoDifensivoToValidata: true, messaggioList: frasi });
  }


  confermaSpostaValidata() {
    this.setState({ loading: true });
    this.detailSanzioneService.changeStato(
      this.state.sanzione,
      this.state.sanzione.idSanzione,
      this.state.idStatoPassagio,
      this.onsuccessModificaSanzione.bind(this)
    );
    this.setState({ showModalScrittoDifensivoToValidata: false });
  }



  confermaCambioStato() {
    this.setState({ loading: true });
    this.detailSanzioneService.changeStato(
      this.state.sanzione,
      this.state.sanzione.idSanzione,
      this.state.idStatoPassagio,
      this.onsuccessModificaSanzione.bind(this)
    );
    this.setState({ showModalAvanzaStato: false });
  }
  annullaCambioStato() {
    this.state.validaInidirizzo.capResponse = "";
    this.state.validaInidirizzo.comuneResponse = "";
    this.state.validaInidirizzo.esito = "";
    this.state.validaInidirizzo.messaggio = "";
    this.state.validaInidirizzo.numeroResponse = "";
    this.state.validaInidirizzo.provinciaResponse = "";
    this.state.validaInidirizzo.viaResponse = "";
    this.setState({ showModalAvanzaStato: false });
  }

  annullaSpostaValidata() {
    this.state.validaInidirizzo.capResponse = "";
    this.state.validaInidirizzo.comuneResponse = "";
    this.state.validaInidirizzo.esito = "";
    this.state.validaInidirizzo.messaggio = "";
    this.state.validaInidirizzo.numeroResponse = "";
    this.state.validaInidirizzo.provinciaResponse = "";
    this.state.validaInidirizzo.viaResponse = "";
    this.setState({ showModalScrittoDifensivoToValidata: false });
  }


  altreAzioniSanzione() {
    this.setState({ showModalChiudiSanzione: true });
  }

  confermaAltriStati() {
    this.setState({ loading: true });
    this.detailSanzioneService.changeStatoAltriStati(
      this.state.sanzione,
      this.state.selectAltriStati,
      this.state.noteAltriStati,
      this.state.sanzione.idSanzione,
      this.state.idStatoPassagio,
      this.onsuccessModificaSanzione.bind(this)
    );
    this.setState({ showModalChiudiSanzione: false });
    this.setState({ noteAltriStati: "" });
    this.setState({ selectAltriStati: "" });
  }
  annullaAltriStati() {
    this.state.buttonAltriStati = true;
    this.setState({ noteAltriStati: "" });
    this.setState({ selectAltriStati: "" });
    this.setState({ showModalChiudiSanzione: false });
  }

  inviaMail() {
    this.setState({ showModalInvioMail: true });
  }

  estendiStoricoSanzione() {
    this.setState({ showModalStoricoSanzione: true });
  }

  confermaInviaMail() {
    //this.setState({loading: true});
    //this.detailSanzioneService.changeStato(this.state.sanzione, this.onsuccessModificaSanzione.bind(this));
    // alert("Funzionalità in sviluppo...");

    this.detailSanzioneService.invioMail(
      this.state.fieldIndirizzoMail,
      this.state.sanzione.numeroSanzione,
      (result) => {
        if (result.status === 200) {
          toast.success("Email inviata");
        } else {
          toast.error("Email non inviata");
        }
      }
    );

    this.setState({ fieldIndirizzoMail: "" });
    this.setState({ showModalInvioMail: false });

    //QUIII
  }
  annullaInviaMail() {
    this.state.fieldIndirizzoMail = "";
    this.setState({ showModalInvioMail: false, isErrorEmail: true });
  }
  chiudiStoricoSanzione() {
    this.setState({ showModalStoricoSanzione: false });
  }
  paga(event) {
    this.state.idStatoPassagio = parseInt(event.target.id);
    if (this.state.sanzione.anagraficaStati.nomeStato === "Rateizzato") {
      var rowSanzione = JSON.parse(sessionStorage.getItem("rowSanzione"));
      this.detailSanzioneService.getDetailRata(rowSanzione.id, (result) => {
        this.state.rata = result.data;
        if (result.status === 200) {
          this.setState({ showModalRateDaPagare: true });
        } else {
          // console.log("error");
        }
      });
    } else {
      //lavoro Paga
      var diff = calculateTimeDifferenceTwoDates(
        new Date(),
        moment(this.state.sanctionEmissionDate).toDate()
      );
      var giorniAllaScadenza = parseInt(diff);
      var isReduced5Days = giorniAllaScadenza <= 5;
      var isReduced60Days = !isReduced5Days && giorniAllaScadenza <= 60;

      isReduced5Days
      ? (this.state.listaSpacchettatiRidotto[0].valore > 0 
        ? this.state.paga.importoNetto = parseFloat(
            this.state.listaSpacchettatiRidotto[0].valore / 100
          )
            .toFixed(2)
            .toString()
            .replace(".", ",")
            : (this.state.listaSpacchettati[0].valore > 0 
              ? this.state.paga.importoNetto = parseFloat(
                this.state.listaSpacchettati[0].valore / 100
              )
              .toFixed(2)
              .toString()
              .replace(".", ",")
            
              : this.state.paga.importoNetto = parseFloat(
                this.state.listaSpacchettatiIntero[0].valore / 100
              )
                .toFixed(2)
                .toString()
                .replace(".", ",")
            )
        )
        : isReduced60Days
          ? (this.state.listaSpacchettati[0].valore > 0 
            ? this.state.paga.importoNetto = parseFloat(
              this.state.listaSpacchettati[0].valore / 100
            )
            .toFixed(2)
            .toString()
            .replace(".", ",")
          
            : this.state.paga.importoNetto = parseFloat(
              this.state.listaSpacchettatiIntero[0].valore / 100
            )
              .toFixed(2)
              .toString()
              .replace(".", ",")
          )
          : this.state.paga.importoNetto = parseFloat(
              this.state.listaSpacchettatiIntero[0].valore / 100
            )
              .toFixed(2)
              .toString()
              .replace(".", ",")

      isReduced5Days
        ? (this.importoUguale = this.state.listaSpacchettatiRidotto[0].valore)
        : (
          isReduced60Days
            ? (this.importoUguale = this.state.listaSpacchettati[0].valore)
            : (this.importoUguale = this.state.listaSpacchettatiIntero[0].valore)
        );

      if (
        parseFloat(this.state.paga.importoNetto * 100) <
        parseFloat(this.importoUguale / 100)
      ) {
        this.setState({ importoInferiroDellaSanzioneDiUnPagamento: true });
      } else {
        if (
          this.state.paga.codiceTx &&
          this.state.paga.dataContabile &&
          this.state.paga.note &&
          this.state.paga.tipoPagamento
        ) {
          this.setState({ importoInferiroDellaSanzioneDiUnPagamento: false });
        }
      }
      this.state.paga.importoNetto.toString().replace(".", ",");

      this.setState({
        showModalPaga: true,
        seIlPagamentoDerivaDaUnaRata: true,
      });
    }
  }

  checkImportoDaPagare(){
    /*if (!this.state.loadingButton){
    let dayLeft = parseInt( calculateTimeDifferenceTwoDates(
      new Date(),
      moment(this.state.sanctionEmissionDate).toDate()
    ));

        
    if(this.state.sanzione.anagraficaStati.nomeStato !== "Rateizzato"){
      if(dayLeft > 5){

        return parseFloat((this.state.paga.importoNetto).replace(",", ".")).toFixed(2) >= (this.state.sanzione.importo / 100)
      }else{
      if(this.state.sanzione.importoRidotto > 0){
        return parseFloat((this.state.paga.importoNetto).replace(",", ".")).toFixed(2) >= (this.state.sanzione.importoRidotto / 100)
      }else{
        return parseFloat((this.state.paga.importoNetto).replace(",", ".")).toFixed(2) >= (this.state.sanzione.importo / 100)
      }
    }
    }else{
      return parseFloat((JSON.stringify(this.state.paga.importoNetto)).replace(",", ".")).toFixed(2) >= this.state.importoDasalvareIDRata;
    }
  }else{
    return false;
  }*/

    return parseFloat((this.state.paga.importoNetto).replace(",", ".")) >= 0.01;
  }


  confermaPaga() {
    //this.setState({loading: true});

    this.state.paga.numeroSanzione = this.state.sanzione.numeroSanzione;
    this.setState({
      loadingButton:true,
      confermaUlteriorreDiunPagamento:true,
    })
    // console.log(this.state.paga)

    // if (
    //   this.state.paga.importoNetto.toString().includes(",") ||
    //   this.state.paga.importoNetto.toString().includes(".")
    // ) {
    //   if (this.state.paga.importoNetto.toString().includes(",")) {
    //     this.state.paga.importoNetto = this.state.paga.importoNetto
    //       .toString()
    //       .replace(",", "");
    //   }
    //   if (this.state.paga.importoNetto.toString().includes(".")) {
    //     this.state.paga.importoNetto = this.state.paga.importoNetto
    //       .toString()
    //       .replace(".", "");
    //   }
    //   this.state.paga.importoNetto = parseInt(this.state.paga.importoNetto);
    // } else {
    //   this.state.paga.importoNetto = parseInt(
    //     this.state.paga.importoNetto * 100
    //   );
    // }

    let importoNetto = this.state.paga.importoNetto;

    if (importoNetto.toString().includes(".")) {
      importoNetto = importoNetto
        .toString()
        .replace(".", ",");
    }
    if (importoNetto.toString().includes(",")) {
      let valoreSplittato = importoNetto.toString().split(",");
      let centesimi = valoreSplittato[1];
      if(centesimi.length == 1) {
        importoNetto = importoNetto + "0";
      } else if(centesimi.length > 2) {
        importoNetto = valoreSplittato[0] + "," + centesimi.substring(0, 2)
      }
      var importointero = importoNetto
        .toString()
        .replace(",", "");
    } else {
      importoNetto = importoNetto + ",00"
      var importointero = importoNetto
        .toString()
        .replace(",", "");
    }

    if (
      importoNetto.toString().includes(".") ||
      importoNetto.toString().includes(",")
    ) {
      this.state.paga.importoNetto = parseFloat(importointero);
    } else {
      this.state.paga.importoNetto = parseFloat(importointero * 100);
    }

    this.detailSanzioneService.pagaSanzioneORata(
      this.state.paga,
      this.state.sanzione.idSanzione,
      this.state.idStatoPassagio,
      (result) => {
        this.setState({showModalPaga:false})
        // console.log(result.status);
        if (result) {
          toast.success(result, {
            position: toast.POSITION.TOP_RIGHT,
          });
          this.setState({ 
            loadingButton:false,
            paga:{
              codiceTx: "",
              dataContabile:getFormatOraInput(new Date()),
              importoNetto:"0",
              note:"",
              numeroRata:"",
              tipoPagamento:"0",
            },
            bloccoTastiAlconfermaPagamento:false,
           });
          setTimeout(()=>{window.location.reload()},3000);
        } else {
          toast.error("Il pagamento non è andato a buon fine", {
            position: toast.POSITION.TOP_RIGHT,
          });
          this.setState({ 
            loadingButton:false,
            paga:{
              codiceTx: "",
              dataContabile:getFormatOraInput(new Date()),
              importoNetto:"0",
              note:"",
              numeroRata:"",
              tipoPagamento:"0",
            },
            bloccoTastiAlconfermaPagamento:false,
           });
        }
      },
      ()=>{
        this.setState({ 
          showModalPaga: false,
          loadingButton:false,
          paga:{
            codiceTx: "",
            dataContabile:getFormatOraInput(new Date()),
            importoNetto:"0",
            note:"",
            numeroRata:"",
            tipoPagamento:"0",
          },
          bloccoTastiAlconfermaPagamento:false,
         });
      }
    );

    // alert("Funzionalità in sviluppo... pagatattata");
  }
  annullaPaga() {
    this.state.paga.codiceTx = "";
    this.state.paga.dataContabile = getFormatOraInput(new Date());
    this.state.paga.importoNetto = "";
    this.state.paga.note = "";
    this.state.paga.numeroRata = "";
    this.state.paga.tipoPagamento = "0";
    this.state.bloccoTastiAlconfermaPagamento = false;
    this.state.confermaUlteriorreDiunPagamento = true;
    this.setState({ showModalPaga: false });
  }

  ravvedimentoOperoso(event) {
    this.state.idStatoPassagio = parseInt(event.target.id);
    this.setState({ showModalRavvedimentoOperoso: true });
    var diff = calculateTimeDifferenceTwoDates(
      new Date(),
      moment(this.state.sanctionEmissionDate).toDate()
    );
    var giorniAllaScadenza = parseInt(diff);
    var isReduced5Days = giorniAllaScadenza <= 5;
    var isReduced60Days = !isReduced5Days && giorniAllaScadenza <= 60;

    isReduced5Days
    ? this.state.nuovoImportoRavvedimentoOperoso =
    (this.state.listaSpacchettatiRidotto[0].valore / 100).toFixed(2).toString().replace(".", ",")
    : (
      isReduced60Days
      ? this.state.nuovoImportoRavvedimentoOperoso =
      (this.state.listaSpacchettati[0].valore / 100).toFixed(2).toString().replace(".", ",")
      : this.state.nuovoImportoRavvedimentoOperoso = (this.state.listaSpacchettatiIntero[0].valore / 100).toFixed(2).toString().replace(".", ",")
    );

    // if(parseFloat(this.state.paga.importoNetto * 100) < parseFloat(this.importoUguale / 100)){
    //   this.setState({importoInferiroDellaSanzioneDiUnPagamento:true})
    // }else{
    //   this.setState({importoInferiroDellaSanzioneDiUnPagamento:false})
    // }
  }

  confermaRavvedimentoOperoso() {
    this.setState({ loading: true });
    this.detailSanzioneService.changeStatoRavOperoso(
      this.state.sanzione,
      parseFloat((this.state.nuovoImportoRavvedimentoOperoso).replace(",", ".")),
      this.state.notaRavvedimentoOperoso,
      this.state.sanzione.idSanzione,
      this.state.idStatoPassagio,
      this.onsuccessModificaSanzione.bind(this)
    );
    this.setState({ notaRavvedimentoOperoso: "" });
    this.setState({
      nuovoImportoRavvedimentoOperoso: (this.state.sanzione.importo / 100).toFixed(2).toString().replace(".", ","),
    });
    this.setState({ showModalRavvedimentoOperoso: false });
  }
  annullaRavvedimentoOperoso() {
    this.setState({ notaRavvedimentoOperoso: "" });
    this.setState({
      nuovoImportoRavvedimentoOperoso: (this.state.sanzione.importo / 100).toFixed(2).toString().replace(".", ","),
    });
    this.setState({
      showModalRavvedimentoOperoso: false,
      isNotaRavvedimentoOperoso: true,
    });
  }

  /* sanzione Pagata */

  changeTextDataContabile(event) {
    this.state.paga.dataContabile = event.target.value;
    this.setState({ paga: this.state.paga });
    if (
      this.state.paga.codiceTx &&
      this.state.paga.dataContabile &&
      this.state.paga.note &&
      this.state.paga.tipoPagamento &&
      this.state.paga.importoNetto
    ) {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: false });
    } else {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: true });
    }
  }
  changeTextImportoNetto(event) {
    this.state.paga.importoNetto = event.target.value
      .toString()
      .replace(".", ",");
    this.setState({ paga: this.state.paga });

    var diff = calculateTimeDifferenceTwoDates(
      new Date(),
      moment(this.state.sanctionEmissionDate).toDate()
    );
    var giorniAllaScadenza = parseInt(diff);
    var isReduced5Days = giorniAllaScadenza <= 5;
    var isReduced60Days = !isReduced5Days && giorniAllaScadenza <= 60;
    this.setState({ importoInferiroDellaSanzioneDiUnPagamento: true });

    isReduced5Days
      ? (this.importoUguale = this.state.listaSpacchettatiRidotto[0].valore)
      : (
        isReduced60Days
          ? (this.importoUguale = this.state.listaSpacchettati[0].valore)
          : (this.importoUguale = this.state.listaSpacchettatiIntero[0].valore)
      );

    // console.log(parseFloat(this.state.paga.importoNetto * 100));
    // console.log(parseFloat(this.importoUguale * 100));

    //

    if (this.state.seIlPagamentoDerivaDaUnaRata === true) {
      if (
        parseFloat(this.state.paga.importoNetto * 100) <
        parseFloat(this.importoUguale)
      ) {
        this.setState({ importoInferiroDellaSanzioneDiUnPagamento: true });
      } else {
        if (
          this.state.paga.codiceTx &&
          this.state.paga.dataContabile &&
          this.state.paga.note &&
          this.state.paga.tipoPagamento
        ) {
          this.setState({ importoInferiroDellaSanzioneDiUnPagamento: false });
        }
      }
    } else {
      this.state.importoRataInferioreAImportoRata =
        this.state.importoRataInferioreAImportoRata.toString().replace(",", "");
      // this.state.paga.importoNetto  =
      // this.state.paga.importoNetto.toString().replace(".", "");
      if (
        parseFloat(this.state.paga.importoNetto * 100) <
        parseFloat(this.state.importoRataInferioreAImportoRata)
      ) {
        this.setState({ importoInferiroDellaSanzioneDiUnPagamento: true });
      } else {
        if (
          this.state.paga.codiceTx &&
          this.state.paga.dataContabile &&
          this.state.paga.note &&
          this.state.paga.tipoPagamento
        ) {
          this.setState({ importoInferiroDellaSanzioneDiUnPagamento: false });
        }
      }
    }
  }
  changeTextCodiceTransazione(event) {
    this.state.paga.codiceTx = event.target.value.toString().toUpperCase();
    this.setState({ paga: this.state.paga });
    if (
      this.state.paga.codiceTx &&
      this.state.paga.dataContabile &&
      this.state.paga.note &&
      this.state.paga.tipoPagamento &&
      this.state.paga.importoNetto
    ) {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: false });
    } else {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: true });
    }
  }
  changeTextNotaPagaSanzione(event) {
    this.state.paga.note = capitalizeFirstLetter(event.target.value);
    this.setState({ paga: this.state.paga });
    if (
      this.state.paga.codiceTx &&
      this.state.paga.dataContabile &&
      this.state.paga.note &&
      this.state.paga.tipoPagamento &&
      this.state.paga.importoNetto
    ) {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: false });
    } else {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: true });
    }
  }
  changeTextTipoPagamento(event) {
    this.state.paga.tipoPagamento = event.target.value;
    this.setState({ paga: this.state.paga });
    // console.log(this.state.paga.tipoPagamento);
    if (
      this.state.paga.codiceTx &&
      this.state.paga.dataContabile &&
      this.state.paga.note &&
      this.state.paga.tipoPagamento &&
      this.state.paga.importoNetto
    ) {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: false });
    } else {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: true });
    }
  }

  changeVerbaleFattoABordo(event) {
    if (this.state.sanzione.isverbaleFattoABordo)
      this.state.sanzione.isverbaleFattoABordo = false;
    else this.state.sanzione.isverbaleFattoABordo = true;
    this.setState({ sanzione: this.state.sanzione });
  }
  /** sanzionato */
  changeTextSanzioneName(event) {
    this.state.sanzione.anagraficaTrasgressore.nome = capitalizeFirstLetter(
      event.target.value
    );
    this.setState({ sanzione: this.state.sanzione });
  }

  changeTextSanzioneCognome(event) {
    this.state.sanzione.anagraficaTrasgressore.cognome = capitalizeFirstLetter(
      event.target.value
    );
    this.setState({ sanzione: this.state.sanzione });
  }
  sexSelectorHandler(event, isPatriaPotesta) {
    const {value} = event.target;

    let sexValue = value !== "" ? this.state.sexList[value] : ""

    if(isPatriaPotesta) {
      this.state.sanzione.anagraficaPotestaTrasgressore.sesso = sexValue
    } else {
      this.state.sanzione.anagraficaTrasgressore.sesso = sexValue
    }

    this.setState({sanzione: this.state.sanzione})
  }
  changeTextSanzioneDataNascita(event) {
    const {name,value} = event.target;

    let date = moment(value).toDate()
    let timestamp = date.getTime();
    let verbalDate = moment(this.state.creaSanzione.dataDiEmissione).toDate();
    let timestampVerbalDate = verbalDate.getTime();
    
    let eighteenYearsInMilliseconds = 18 * 365 * 24 * 60 * 60 * 1000;
    
    let tempo = (timestampVerbalDate - timestamp) > eighteenYearsInMilliseconds;

    this.state.sanzione.anagraficaTrasgressore.dataDiNascita = timestamp;
    

    if (tempo) {
      this.state.sanzione.anagraficaTrasgressore.isMinorenne = 0;
    } else {
      this.state.sanzione.anagraficaTrasgressore.isMinorenne = 1;
     }
    // console.log(event.target.value);
    // if (
    //   !validDate.test(this.state.sanzione.anagraficaTrasgressore.dataDiNascita)
    // ) {
    //   this.setState({ errorDataDiNascitaTrasgessore: true });
    // } else {
    //   this.setState({ errorDataDiNascitaTrasgessore: false });
    // }

    this.setState({ sanzione: this.state.sanzione });
  }
  changeTextSanzioneCF(event) {
    this.state.sanzione.anagraficaTrasgressore.codiceFiscale =
      event.target.value.toString().toUpperCase();
    if (
      !validCF.test(this.state.sanzione.anagraficaTrasgressore.codiceFiscale)
    ) {
      this.setState({ errorCFTrasgessore: true });
    } else {
      this.setState({ errorCFTrasgessore: false });
    }
    this.setState({ sanzione: this.state.sanzione });
  }
  changeTextSanzioneLuogoNascita(event) {
    this.state.sanzione.anagraficaTrasgressore.luogoDiNascita =
      capitalizeFirstLetter(event.target.value);
    this.setState({ sanzione: this.state.sanzione });
  }
  changeTextSanzioneNDoc(event) {
    this.state.sanzione.anagraficaTrasgressore.numeroDocumento =
      event.target.value.toString().toUpperCase();
    this.setState({ sanzione: this.state.sanzione });
  }
  changeTextSanzioneDataDoc(event) {
    this.state.sanzione.anagraficaTrasgressore.dataRilascioDocumento =
      event.target.value;
    // if (
    //   !validDate.test(
    //     this.state.sanzione.anagraficaTrasgressore.dataRilascioDocumento
    //   )
    // ) {
    //   this.setState({ errorDataDiRilascioTrasgessore: true });
    // } else {
    //   this.setState({ errorDataDiRilascioTrasgessore: false });
    // }
    this.setState({ sanzione: this.state.sanzione });
  }

  //todo metodo cambio input
  changeTextTipoDocumento(event){
    this.state.sanzione.anagraficaTrasgressore.tipoDocumento = event.target.value;

    this.setState({sanzione:this.state.sanzione});

  }
  changeTextSanzioneEnteRilascioDoc(event) {
    this.state.sanzione.anagraficaTrasgressore.enteRilascioDocumento =
      event.target.value;
    this.setState({ sanzione: this.state.sanzione });
  }
  changeTextSanzioneComuneResidenza(event) {
    this.state.sanzione.anagraficaTrasgressore.comuneDiResidenza =
      capitalizeFirstLetter(event.target.value);
    this.setState({ sanzione: this.state.sanzione });
  }
  changeTextSanzioneIndirizzoResidenza(event) {
    this.state.sanzione.anagraficaTrasgressore.inidirizzoDiResidenza =
      capitalizeFirstLetter(event.target.value);
    this.setState({ sanzione: this.state.sanzione });
  }
  changeTextSanzioneNumIndirizzoResidenza(event) {
    this.state.sanzione.anagraficaTrasgressore.inidirizzoNumeroDiResidenza =
      event.target.value;
    this.setState({ sanzione: this.state.sanzione });
  }
  changeTextSanzioneCapResidenza(event) {
    this.state.sanzione.anagraficaTrasgressore.capDiResidenza =
      event.target.value;
    this.setState({ sanzione: this.state.sanzione });
  }
  changeTextSanzionePRResidenza(event) {
    this.state.sanzione.anagraficaTrasgressore.provinciaDiResidenza =
      event.target.value.toString().toUpperCase();
    this.setState({ sanzione: this.state.sanzione });
  }
  /** Patria potesta */
  changeTextSanzioneNameP(event) {
    this.state.sanzione.anagraficaPotestaTrasgressore.nome =
      capitalizeFirstLetter(event.target.value);
    this.setState({ sanzione: this.state.sanzione });
  }
  changeTextSanzioneCognomeP(event) {
    this.state.sanzione.anagraficaPotestaTrasgressore.cognome =
      capitalizeFirstLetter(event.target.value);
    this.setState({ sanzione: this.state.sanzione });
  }
  changeTextSanzioneDataNascitaP(event) {
    this.state.sanzione.anagraficaPotestaTrasgressore.dataDiNascita =
      event.target.value;
    
    // if (
    //   !validDate.test(
    //     this.state.sanzione.anagraficaPotestaTrasgressore.dataDiNascita
    //   )
    // ) {
    //   this.setState({ errorDataDiNascitaTrasgessorePatria: true });
    // } else {
    //   this.setState({ errorDataDiNascitaTrasgessorePatria: false });
    // }
    this.setState({ sanzione: this.state.sanzione });
  }
  changeTextSanzioneCFP(event) {
    this.state.sanzione.anagraficaPotestaTrasgressore.codiceFiscale =
      event.target.value.toString().toUpperCase();
    if (
      !validCF.test(
        this.state.sanzione.anagraficaPotestaTrasgressore.codiceFiscale
      )
    ) {
      this.setState({ errorCFTrasgessorePatria: true });
    } else {
      this.setState({ errorCFTrasgessorePatria: false });
    }
    this.setState({ sanzione: this.state.sanzione });
  }
  changeTextSanzioneLuogoNascitaP(event) {
    this.state.sanzione.anagraficaPotestaTrasgressore.luogoDiNascita =
      capitalizeFirstLetter(event.target.value);
    this.setState({ sanzione: this.state.sanzione });
  }

  changeTextSanzioneNDocP(event) {
    this.state.sanzione.anagraficaPotestaTrasgressore.numeroDocumento =
      event.target.value.toString().toUpperCase();
    this.setState({ sanzione: this.state.sanzione });
  }
  changeTextSanzioneDataDocP(event) {
    this.state.sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento =
      event.target.value;
    // if (
    //   !validDate.test(
    //     this.state.sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento
    //   )
    // ) {
    //   this.setState({ errorDataDiRilascioTrasgessorePatria: true });
    // } else {
    //   this.setState({ errorDataDiRilascioTrasgessorePatria: false });
    // }

    this.setState({ sanzione: this.state.sanzione });
  }
  changeTextSanzioneEnteRilascioDocP(event) {
    this.state.sanzione.anagraficaPotestaTrasgressore.enteRilascioDocumento =
      capitalizeFirstLetter(event.target.value);
    this.setState({ sanzione: this.state.sanzione });
  }

  //todo cambio tipo documento per minori
  changeTextTipoDocumentoP(event){
    this.state.sanzione.anagraficaPotestaTrasgressore.tipoDocumento = capitalizeFirstLetter(event.target.value);
    this.setState({sanzione:this.state.sanzione});
  }
  changeTextSanzioneComuneResidenzaP(event) {
    this.state.sanzione.anagraficaPotestaTrasgressore.comuneDiResidenza =
      capitalizeFirstLetter(event.target.value);
    this.setState({ sanzione: this.state.sanzione });
  }
  changeTextSanzioneIndirizzoResidenzaP(event) {
    this.state.sanzione.anagraficaPotestaTrasgressore.inidirizzoDiResidenza =
      capitalizeFirstLetter(event.target.value);
    this.setState({ sanzione: this.state.sanzione });
  }
  changeTextSanzioneNumIndirizzoResidenzaP(event) {
    this.state.sanzione.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza =
      event.target.value;
    this.setState({ sanzione: this.state.sanzione });
  }
  changeTextSanzioneCapResidenzaP(event) {
    this.state.sanzione.anagraficaPotestaTrasgressore.capDiResidenza =
      event.target.value;
    this.setState({ sanzione: this.state.sanzione });
  }
  changeTextSanzionePRResidenzaP(event) {
    this.state.sanzione.anagraficaPotestaTrasgressore.provinciaDiResidenza =
      event.target.value.toString().toUpperCase();
    this.setState({ sanzione: this.state.sanzione });
  }

  /** dettaglio sanzione  */
  changeTextSanzioneLocalita(event) {
    this.state.sanzione.localita = capitalizeFirstLetter(
      event.target.value
    );
    this.setState({ sanzione: this.state.sanzione });
  }

  changeTextSanzioneAnnotazione(event) {
    this.state.sanzione.annotazioneControllore = capitalizeFirstLetter(
      event.target.value
    );
    this.setState({ sanzione: this.state.sanzione });
  }

  changeTextSanzioneAnnotazioneTrasgressore(event){
    this.state.sanzione.noteTrasgressore = capitalizeFirstLetter(
      event.target.value
    );
    this.setState({ sanzione: this.state.sanzione });

  }

  changeTextEventualiNotePagamento(event) {
    this.state.paga.note = capitalizeFirstLetter(event.target.value);
    this.setState({ paga: this.state.paga });
    if (
      this.state.paga.codiceTx &&
      this.state.paga.dataContabile &&
      this.state.paga.note &&
      this.state.paga.tipoPagamento &&
      this.state.paga.importoNetto
    ) {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: false });
    } else {
      this.setState({ importoInferiroDellaSanzioneDiUnPagamento: true });
    }
  }

  changeTextImportoRavvedimentoOperoso(event) {
    this.state.nuovoImportoRavvedimentoOperoso = event.target.value;
    this.setState({
      nuovoImportoRavvedimentoOperoso:
        this.state.nuovoImportoRavvedimentoOperoso,
    });
    if (
      this.state.notaRavvedimentoOperoso.length < 5
    ) {
      this.state.isNotaRavvedimentoOperoso = true;
    } else {
      this.state.isNotaRavvedimentoOperoso = false;
    }
  }
  changeTextNotaRavvedimentoOperoso(event) {
    this.state.notaRavvedimentoOperoso = event.target.value;
    this.setState({
      notaRavvedimentoOperoso: this.state.notaRavvedimentoOperoso,
    });
    if (
      this.state.notaRavvedimentoOperoso.length >= 5
    ) {
      this.state.isNotaRavvedimentoOperoso = false;
    } else {
      this.state.isNotaRavvedimentoOperoso = true;
    }
  }

  changeTextIndirizzoInvioMail(event) {
    //ESIMg
    this.state.fieldIndirizzoMail = event.target.value;
    this.setState({ fieldIndirizzoMail: this.state.fieldIndirizzoMail });
    if (!validEmail.test(this.state.fieldIndirizzoMail)) {
      this.setState({ isErrorEmail: true });
    } else {
      this.setState({ isErrorEmail: false });
    }
  }

  changeTextnoteAltriStati(event) {
    this.state.noteAltriStati = event.target.value;
    this.setState({ noteAltriStati: this.state.noteAltriStati });
    // if (this.state.noteAltriStati.length >= 5) {
    //   this.setState({ buttonAltriStati: false });
    // } else {
    //   this.setState({ buttonAltriStati: true });
    // }
    // if (
    //   this.state.selectAltriStati === 0 ||
    //   this.state.selectAltriStati === "Scegli altri Stati"
    // ) {
    //   this.setState({ buttonAltriStati: true });
    // }
  }

  changeSelectStatoAltriStati(event) {
    // this.state.listaStatiTo.map((valore) => {
    //   if (valore.idStato === parseInt(event.target.value)) {
    //     this.state.selectAltriStati = valore.nomeStato;
    //   }
    // });

    this.setState({ selectAltriStati: parseInt(event.target.value) }); //this.state.selectAltriStati === 0 ||
    // console.log(this.state.selectAltriStati === "Scegli altri Stati");
    // console.log(this.state.selectAltriStati);
    this.state.idStatoPassagio = parseInt(event.target.value);
    if (this.state.selectAltriStati === 0) {
      this.setState({ buttonAltriStati: true });
    } else {
      this.setState({ buttonAltriStati: false });
    }

    if (this.state.noteAltriStati.length >= 5) {
      this.setState({ buttonAltriStati: false });
    } else {
      this.setState({ buttonAltriStati: true });
    }

    if (this.state.selectAltriStati === "Scegli altri Stati") {
      this.setState({ buttonAltriStati: true });
    } else {
      this.setState({ buttonAltriStati: false });
    }
  }

  /** maggiorenne */
  changeIsMaggiorenne(event) {
    if (this.state.sanzione.anagraficaTrasgressore.isMinorenne) {
      this.state.sanzione.anagraficaTrasgressore.isMinorenne = false;
      this.setState({ buttonValidaSanzione: true });
      this.state.sanzione.anagraficaPotestaTrasgressore.nome = "";
      this.state.sanzione.anagraficaPotestaTrasgressore.cognome = "";
      this.state.sanzione.anagraficaPotestaTrasgressore.dataDiNascita = "";
      this.state.sanzione.anagraficaPotestaTrasgressore.luogoDiNascita = "";
      this.state.sanzione.anagraficaPotestaTrasgressore.isMinorenne = false;
      this.state.sanzione.anagraficaPotestaTrasgressore.numeroDocumento = "";
      this.state.sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento =
        "";
      this.state.sanzione.anagraficaPotestaTrasgressore.tipoDocumento = "";
      this.state.sanzione.anagraficaPotestaTrasgressore.comuneDiResidenza = "";
      this.state.sanzione.anagraficaPotestaTrasgressore.inidirizzoDiResidenza =
        "";
      this.state.sanzione.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza =
        "";
      this.state.sanzione.anagraficaPotestaTrasgressore.frazione = "";
      this.state.sanzione.anagraficaPotestaTrasgressore.provinciaDiResidenza =
        "";
      this.state.sanzione.anagraficaPotestaTrasgressore.capDiResidenza = "";
      this.state.sanzione.anagraficaPotestaTrasgressore.codiceFiscale = "";
      this.state.sanzione.anagraficaPotestaTrasgressore.enteRilascioDocumento =
        "";
    } else {
      this.state.sanzione.anagraficaTrasgressore.isMinorenne = true;
      this.setState({ buttonValidaSanzione: true });
      // this.state.sanzione.anagraficaPotestaTrasgressore.nome = ""
      // this.state.sanzione.anagraficaPotestaTrasgressore.cognome = ""
      // this.state.sanzione.anagraficaPotestaTrasgressore.dataDiNascita = ""
      // this.state.sanzione.anagraficaPotestaTrasgressore.luogoDiNascita = ""
      // this.state.sanzione.anagraficaPotestaTrasgressore.isMinorenne = false
      // this.state.sanzione.anagraficaPotestaTrasgressore.numeroDocumento = ""
      // this.state.sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento = ""
      // this.state.sanzione.anagraficaPotestaTrasgressore.comuneDiResidenza = ""
      // this.state.sanzione.anagraficaPotestaTrasgressore.inidirizzoDiResidenza = ""
      // this.state.sanzione.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza = ""
      // this.state.sanzione.anagraficaPotestaTrasgressore.frazione = ""
      // this.state.sanzione.anagraficaPotestaTrasgressore.provinciaDiResidenza = ""
      // this.state.sanzione.anagraficaPotestaTrasgressore.capDiResidenza = ""
      // this.state.sanzione.anagraficaPotestaTrasgressore.codiceFiscale = ""
    }
    this.setState({ sanzione: this.state.sanzione });
    //this.showDatiAnagraficaPatriaPotesta();
  }

  AnnullaScrittoDifensivo() {
    this.setState({ scrittoDifensivo: [], buttonScrittoDifensivo: true });
    this.setState({ showModalScrittoDifensivo: false });
    // console.log(this.state.scrittoDifensivoAllegatoBase64);
  }

  CanfermaScrittoDifensivo() {
    this.state.sanzione.anagraficaStati.nomeStato = "Scritto Difensivo";
    this.detailSanzioneService.changeStatoAltriStati(
      this.state.sanzione,
      "Scritto Difensivo",
      this.state.scrittoDifensivo.DescrizioneScrittoDifensivo,
      this.state.sanzione.idSanzione,
      this.state.idStatoPassagio,
      this.onsuccessModificaSanzione.bind(this)
    );
    // console.log(this.state.scrittoDifensivo);
    this.setState({ scrittoDifensivo: [] });
    this.setState({ showModalScrittoDifensivo: false });
  }

  showScrittoDifensivo(event) {
    this.state.idStatoPassagio = parseInt(event.target.id);
    this.setState({ showModalScrittoDifensivo: true });
  }

  changeDescrizioneScrittoDifensivo(event) {
    this.state.scrittoDifensivo.DescrizioneScrittoDifensivo =
      event.target.value;
    this.setState({ scrittoDifensivo: this.state.scrittoDifensivo });
    if (this.state.scrittoDifensivo.DescrizioneScrittoDifensivo.length >= 5) {
      this.state.buttonScrittoDifensivo = false;
    }
  }
  changeAllegatoScrittoDifensivo = async (event) => {
    // this.state.scrittoDifensivo.allegato = event.target.value;
    const file = event.target.files[0];
    const fileBase64 = await this.convertBase64(file);
    // let baseCaricato = "";
    // fileBase64.then((value) => {
    //    if(value === ""){

    //    }else{
    //     //  this.setState({baseCaricato:value})
    //   }
    // })
    // console.log(fileBase64)

    this.state.scrittoDifensivo.allegato = event.target.value;
    this.setState({
      scrittoDifensivo: this.state.scrittoDifensivo,
      allegatiSanzioneAggiungiBase64: fileBase64,
    });
    // .catch(err => {
    //   console.log(err);
    // });;
    // console.log(event.target.files[0])//contenuto del file completo Data ultima modifica grandezza e molto altro
  };

  convertBase64 = async (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      // fileReader.onerror = (error) => {
      //   reject(error);
      // };
    });
  };

  modalScrittoDifensivo() {
    return (
      <>
        <Modal size="xl" show={this.state.showModalScrittoDifensivo}>
          <Modal.Header>
            <Modal.Title>Crea scritto difensivo</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="col">
              <label>Scritto difensivo</label>
              <textarea
                className="form-control"
                type="area"
                placeholder="Scritto difensivo (minimo 5 caratteri)"
                value={this.state.scrittoDifensivo.scrittoDifensivo}
                onChange={this.changeDescrizioneScrittoDifensivo.bind(this)}
                // disabled={this.state.disableInput}
              ></textarea>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.AnnullaScrittoDifensivo.bind(this)}
            >
              Annulla
            </Button>
            <Button
              variant="primary"
              onClick={this.CanfermaScrittoDifensivo.bind(this)}
              disabled={this.state.buttonScrittoDifensivo}
            >
              Conferma
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
  showModalBolletinoPostale() {
    this.setState({ showModalBolletinoPostale: true });
  }
  AnnullaBolletinoPostale() {
    this.setState({ showModalBolletinoPostale: false });
  }

  bollettinoPostale() {
    return (
      <>
        <Modal size="lg" show={this.state.showModalBolletinoPostale}>
          <Modal.Header>
            <Modal.Title>Bollettino Postale</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>Non sono stati generati bolletini postali per questa sanzione</>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.AnnullaBolletinoPostale.bind(this)}
            >
              Chiudi Scheda
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  getTentativiPagamento() {
    this.detailSanzioneService.getListaTentativiPagamento(
      this.state.sanzione.numeroSanzione,
      (result) => {
        this.setState({ tentativiPagamento: result.data });
        // console.log(this.state.tentativiPagamento)
      }
    );
  }

  showModalTentativiPagamento() {
    this.getTentativiPagamento();

    this.setState({ showModalTentativiPagamento: true });
  }

  closeModalTentativiPagamento() {
    this.setState({ showModalTentativiPagamento: false });
  }

  showModalGestioneAllegati() {
    this.detailSanzioneService.getListaAllegatiSanzione(
      this.state.sanzione.numeroSanzione,
      (result) => {
        this.setState({ allegatiSanzione: result.data });
        // console.log(this.state.allegatiSanzione)
      }
    );

    this.setState({ showModalGestioneAllegati: true });
  }

  showModalGestioneAllegatiAggiungiScritto() {
    this.detailSanzioneService.getListaAllegatiSanzione(
      this.state.sanzione.numeroSanzione,
      (result) => {
        this.setState({ allegatiSanzione: result.data });
        // console.log(this.state.allegatiSanzione)
      }
    );

    this.setState({ showModalGestioneAllegati: true, AggiungiAllegato: true });
  }
  annulaGestioneAllegati() {
    this.setState({
      showModalGestioneAllegati: false,
      AggiungiAllegato: false,
      allegatiSanzioneAggiungiBase64: "",
    });
  }

  changeAggiungiAllegato = async (event) => {
    // this.state.scrittoDifensivo.allegato = event.target.value;
    const file = event.target.files[0];
    const fileBase64 = await this.convertBase64(file);
    // let baseCaricato = "";
    // fileBase64.then((value) => {
    //    if(value === ""){

    //    }else{
    //     //  this.setState({baseCaricato:value})
    //   }
    // })
    // console.log(file);
    // console.log(fileBase64);

    if (file.size > 4718592) {
      this.setState({
        allegatiSanzioneAggiungiBase64: "",
        errorDimensioneFile: true,
        fileSizeError: true,
      });
    } else {
      this.state.fileSizeError = false;
      this.state.errorDimensioneFile = false;
    }

    this.state.allegatiSanzione.file = event.target.value;
    this.setState({
      allegatiSanzione: this.state.allegatiSanzione,
      nomeFile: file.name,
      // allegatiSanzioneAggiungiBase64: fileBase64,
      allegatiSanzioneAggiungiBase64: event.target.files[0],
    });

    // console.log(this.state.allegatiSanzioneAggiungiBase64);
    // console.log(this.state.nomeFile);
    // .catch(err => {
    //   console.log(err);
    // });;
    // console.log(event.target.files[0])//contenuto del file completo Data ultima modifica grandezza e molto altro
  };

  buttonAggiungiAllegato() {
    // const base= this.state.allegatiSanzioneAggiungiBase64.indexOf(",")
    // const baseinvio = this.state.allegatiSanzioneAggiungiBase64.substring(base +1, this.state.allegatiSanzioneAggiungiBase64.length)
    // console.log(baseinvio);
    // console.log(this.state.nomeFile);
    // this.setState({ AggiungiAllegato: false });
    // toast.success("Funzionalita in sviluppo");
    this.setState({loadingAllegato:true});
    this.allegato = {
      id: 0,
      // "nomeFile":this.state.nomeFile,
      nomeFile: this.state.nomeFile,
      // "file":baseinvio,
      file: this.state.allegatiSanzioneAggiungiBase64,
    };

    const formData = new FormData();
    formData.append("file", this.state.allegatiSanzioneAggiungiBase64);

    this.detailSanzioneService.aggiungiAllegato(
      this.state.sanzione.numeroSanzione,
      formData,
      (result) => {
        this.setState({loadingAllegato:false});
        if (result.status === 200) {
          // console.log(result);
          if(result.data === true){
            toast.success("Allegato aggiunto con successo");
          }else{
            toast.error("Allegato non aggiunto con successo")
          }
          setTimeout(()=>window.location.reload(),3000);
          this.detailSanzioneService.getListaAllegatiSanzione(
            this.state.sanzione.numeroSanzione,
            (result) => {
              // this.setState({ allegatiSanzione: result.data });
              // console.log(this.state.allegatiSanzione)

              this.detailSanzioneService.getListaAllegatiSanzione(
                this.state.sanzione.numeroSanzione,
                (result) => {
                  this.setState({ allegatiSanzione: result.data });
                  // console.log(this.state.allegatiSanzione)
                }
              );
            }
          );
          this.setState({
            allegatiSanzioneAggiungiBase64: "",
            AggiungiAllegato: false,
          });
        } else {
          this.setState({loadingAllegato:false});
          toast.error("Allegato non aggiunto con successo");
          this.setState({ allegatiSanzioneAggiungiBase64: "" });
        }
      }
    );
  }

  gestioneTentativiModal() {
    // this.AggiungiAllegato = false;
    return (
      <>
        <Modal size="lg" show={this.state.showModalTentativiPagamento}>
          <Modal.Header>
            <Modal.Title>Tentativi di pagamento online</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>
            {
              <table class="table table-bordered text-center">
                {" "}
                {this.state.tentativiPagamento.map((dati, index) => {
                  // console.log(dati.data);
                  /*var giornoCorretto =
                    new Date(dati.dataTentativo).getDate() < 9
                      ? "0" + new Date(dati.dataTentativo).getDate()
                      : new Date(dati.dataTentativo).getDate();
                  var meseCorretto =
                    new Date(dati.dataTentativo).getMonth() < 9
                      ? "0" + (new Date(dati.dataTentativo).getMonth() + 1)
                      : new Date(dati.dataTentativo).getMonth() + 1;
                  var dataCoretta =
                    giornoCorretto +
                    "/" +
                    meseCorretto +
                    "/" +
                    new Date(dati.dataTentativo).getFullYear();*/
                  return (
                    <>
                      {index === 0 ? (
                        <thead>
                          <tr>
                            <th scope="col">Data tentativo</th>
                            <th scope="col">Importo</th>
                            <th scope="col">Esito</th>
                            <th scope="col">Annulla</th>
                          </tr>
                        </thead>
                      ) : (
                        ""
                      )}
                      <tbody>
                        <tr className="">
                          <td>{getDataFormatWithTime(dati.dataTentativo)}</td>
                          <td>€ {parseFloat(dati.importo / 100).toFixed(2)}</td>
                          <td>{dati.esito}</td>
                          {(dati.esito === "PENDING") &&<td>
                            <button
                              className="btn btn-link"
                              style={{ color: "red" }}
                              onClick={() => this.showModalConfermaAnnullaTentativoPagamentoHandler(dati)}
                              // href={
                              //   "data:application/" +
                              //   dati.nomeFile +
                              //   ".pdf;base64," +
                              //   this.gestioneFile
                              // }
                              // title={dati.nomeFile + ".pdf"}
                              // download={dati.nomeFile + ".pdf"}
                            >
                              <i className="fas fa-times" color="red"></i>
                            </button>
                          </td>}
                        </tr>
                      </tbody>
                    </>
                  );
                })}
              </table>
            }
          </>
          </Modal.Body>
          <Modal.Footer>
            {
              <Button
                variant="secondary"
                onClick={this.closeModalTentativiPagamento.bind(this)}
              >
                Chiudi Scheda
              </Button>
            }
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  gestioneAllegatiModal() {
    // this.AggiungiAllegato = false;
    return (
      <>
        <Modal size="lg" show={this.state.showModalGestioneAllegati}>
          <Modal.Header>
            <Modal.Title>Gestione Allegati</Modal.Title>
            {!(this.state.sanzione.anagraficaStati.nomeStato === "Annullata" ||this.state.sanzione.anagraficaStati.nomeStato === "Agli Atti") &&<button
              type="button"
              disabled={this.state.allegatiSanzione.length === 3  || this.state.sanzione.anagraficaStati.nomeStato === "Annullata" ||this.state.sanzione.anagraficaStati.nomeStato === "Agli Atti"}
              className="btn btn-warning"
              onClick={() => this.setState({ AggiungiAllegato: true })}
            >
              <i className="fas  fa-print text-white"></i> Aggiungi Allegato
            </button>}
          </Modal.Header>
          <Modal.Body>
            <>
            {this.state.AggiungiAllegato ? (
              <>
                <label>Allegati</label>
                <input
                  className="form-control"
                  type="file"
                  accept=".png, .jpg, .jpeg, .pdf"
                  value={this.state.allegatiSanzione.file}
                  onChange={this.changeAggiungiAllegato.bind(this)}
                  // disabled={this.state.disableInput}
                ></input>
                <br></br>
                <small>
                  Formati accettati<br></br> pdf, jpg, png.
                </small>
                <br></br>
                {this.state.errorDimensioneFile ? (
                  <small className="text-danger">
                    File superiore di 4,5 MB
                  </small>
                ) : (
                  ""
                )}
              </>
            ) : (
              <table class="table table-bordered text-center">
                {" "}
                {this.state.allegatiSanzione.map((dati, index) => {
                  // console.log(dati.data);
                  var giornoCorretto =
                    new Date(dati.data).getDate() < 9
                      ? "0" + new Date(dati.data).getDate()
                      : new Date(dati.data).getDate();
                  var meseCorretto =
                    new Date(dati.data).getMonth() < 9
                      ? "0" + (new Date(dati.data).getMonth() + 1)
                      : new Date(dati.data).getMonth() + 1;
                  var dataCoretta =
                    giornoCorretto +
                    "/" +
                    meseCorretto +
                    "/" +
                    new Date(dati.data).getFullYear();
                  return (
                    <>
                      {index === 0 ? (
                        <thead>
                          <tr>
                            <th scope="col">Data Creazione</th>
                            <th scope="col">Nome File</th>
                            <th scope="col">Allegato</th>
                            {!(this.state.sanzione.anagraficaStati.nomeStato === "Annullata" ||this.state.sanzione.anagraficaStati.nomeStato === "Agli Atti") &&<th scope="col">Elimina</th>}
                          </tr>
                        </thead>
                      ) : (
                        ""
                      )}
                      <tbody>
                        <tr className="">
                          <td>{geDataFormat(dati.data)}</td>
                          <td>{dati.nomeFile}</td>
                          <td>
                            <button
                              className="btn btn-link"
                              onClick={() => {
                                this.detailSanzioneService.detailAllegatoBase64(
                                  dati.id,
                                  (result) => {
                                    // console.log(); //result.data);
                                    {
                                      let a = document.createElement("a");
                                      a.href =
                                        "data:application/" +
                                        dati.nomeFile +
                                        ";base64," +
                                        result.data;
                                      a.download = dati.nomeFile;
                                      a.title = dati.nomeFile;
                                      a.click();
                                    }
                                  }
                                );
                              }}
                              // href={
                              //   "data:application/" +
                              //   dati.nomeFile +
                              //   ".pdf;base64," +
                              //   this.gestioneFile
                              // }
                              // title={dati.nomeFile + ".pdf"}
                              // download={dati.nomeFile + ".pdf"}
                            >
                              <i className="fas fa-download"></i>
                            </button>
                            {/* <a
                                href={
                                  "data:application/" +
                                  dati.nomeFile +
                                  ".pdf;base64," +
                                  this.gestioneFile
                                }
                                title={dati.nomeFile + ".pdf"}
                                download={dati.nomeFile + ".pdf"}
                              >
                                <i className="fas fa-download"></i>
                              </a> */}
                          </td>
                          {!(this.state.sanzione.anagraficaStati.nomeStato === "Annullata" ||this.state.sanzione.anagraficaStati.nomeStato === "Agli Atti") &&<td>
                            <button
                              className="btn btn-link"
                              style={{ color: "red" }}
                              onClick={() => this.showModalConfermaEliminaAllegatoHandler(dati)}
                              // href={
                              //   "data:application/" +
                              //   dati.nomeFile +
                              //   ".pdf;base64," +
                              //   this.gestioneFile
                              // }
                              // title={dati.nomeFile + ".pdf"}
                              // download={dati.nomeFile + ".pdf"}
                            >
                              <i className="fas fa-trash" color="red"></i>
                            </button>
                          </td>}
                        </tr>
                      </tbody>
                    </>
                  );
                })}
              </table>
            )}
          </>
          </Modal.Body>
          <Modal.Footer>
            {this.state.AggiungiAllegato ? (
              <>
                <Button
                  variant="primary"
                  disabled={this.state.fileSizeError || this.state.loadingAllegato}
                  onClick={this.buttonAggiungiAllegato.bind(this)}
                >
                  {this.state.loadingAllegato ?<LoadSpinner/> : "Aggiungi Allegato"}
                </Button>
                <Button
                  variant="secondary"
                  onClick={this.annulaGestioneAllegati.bind(this)}
                >
                  Chiudi Scheda
                </Button>
              </>
            ) : (
              <Button
                variant="secondary"
                onClick={this.annulaGestioneAllegati.bind(this)}
              >
                Chiudi Scheda
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  confermaAnnullaTentativoPagamento(){
    this.detailSanzioneService.annullaTentativoPagamento(
      this.state.sanzione.numeroSanzione,
      this.state.tentativoPagamentoDaAnnullare.id,
      (result) => {
        // console.log(result);
        if (result.status === 200) {
          toast.success(
            "Annullamento avvenuto con successo"
          );
          this.getTentativiPagamento();
          this.showModalConfermaAnnullaTentativoPagamentoHandler()
        } else {
          let error = (result != null && result != undefined) && (result.data != null && result.data != undefined) ? result.data : "Errore durante l'operazione";
          toast.error(result.data);
          this.showModalConfermaAnnullaTentativoPagamentoHandler()
        }
      }
    );
  }

  confermaEliminaAllegato(){
    this.detailSanzioneService.eliminaAllegato(
      this.state.sanzione.numeroSanzione,
      this.state.allegatoDaEliminare.id,
      (result) => {
        // console.log(result);
        if (result.status === 200) {
          toast.success(
            "Eliminazione avvenuta con successo"
          );
          setTimeout(()=>window.location.reload(),3000);
          this.detailSanzioneService.getListaAllegatiSanzione(
            this.state.sanzione.numeroSanzione,
            (result) => {
              this.setState({
                allegatiSanzione: result.data,
              });
              // console.log(this.state.allegatiSanzione)
            }
          );
          this.showModalConfermaEliminaAllegatoHandler()
        } else {
          toast.error("File non eliminato");
          this.showModalConfermaEliminaAllegatoHandler()
        }
      }
    );
  }

  modalConfermaAnnullaTentativoPagamento(){
    return(
      <>
        <Modal show={this.state.showModalConfermaAnnullaTentativoPagamento}>
          <Modal.Header>
            <Modal.Title>Annulla tentativo di pagamento</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Sei sicuro di voler annullare il tentativo di pagamento effettuato in data {getDataFormatWithTime(this.state.tentativoPagamentoDaAnnullare.dataTentativo)}?
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={()=>this.showModalConfermaAnnullaTentativoPagamentoHandler()}
            >
              Annulla
            </Button>
            <Button variant="danger" onClick={()=>this.confermaAnnullaTentativoPagamento()}>
              Conferma 
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    )
  }

  modalConfermaEliminaAllegato(){
    return(
      <>
        <Modal show={this.state.showModalConfermaEliminaAllegato}>
          <Modal.Header>
            <Modal.Title>Elimina Allegato</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Sei sicuro di voler Eliminare L'allegato: {this.state.allegatoDaEliminare.nomeFile}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={()=>this.showModalConfermaEliminaAllegatoHandler()}
            >
              Annulla
            </Button>
            <Button variant="danger" onClick={()=>this.confermaEliminaAllegato()}>
              Conferma 
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    )
  }

  AnnullaPagaRata() {
    this.setState({ showModalRateDaPagare: false });
  }
  modalRateDaPagare() {
    return (
      <>
        <Modal size="lg" show={this.state.showModalRateDaPagare}>
          <Modal.Header>
            <Modal.Title>Totale delle rate</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>
              <div className="container">
                <table class="table table-bordered">
                  <thead className="text-center">
                    <tr>
                      <th>Numero Rata</th>
                      <th>Importo Da Pagare</th>
                      <th>Scadenza</th>
                      {/* <th>Stato Pagamento</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.rata.rate.map((data) => {
                      const rataDapagare = this.state.rata.rate
                        .map((itm) => itm.stato)
                        .indexOf("daPagare");

                      this.giornoScadenza =
                        new Date(data.dataScandenza).getDate() < 10
                          ? "0" + new Date(data.dataScandenza).getDate()
                          : new Date(data.dataScandenza).getDate();
                      this.meseScadenza =
                        new Date(data.dataScandenza).getMonth() + 1 < 10
                          ? "0" + (new Date(data.dataScandenza).getMonth() + 1)
                          : new Date(data.dataScandenza).getMonth() + 1;
                      this.annoScadenza = new Date(
                        data.dataScandenza
                      ).getFullYear();

                      this.dataScadenzaCorrerra =
                        this.giornoScadenza +
                        "/" +
                        this.meseScadenza +
                        "/" +
                        this.annoScadenza;

                      data.importo = parseFloat(data.importo / 100).toFixed(2);
                      // var arrayDiIMportoRidotto = data.importo.toString().split("");

                      // console.log(arrayDiIMportoRidotto[arrayDiIMportoRidotto.length - 1]);
                      // if (arrayDiIMportoRidotto[arrayDiIMportoRidotto.length - 1] === "0") {
                      //   data.importo = data.importo + "0";
                      // }

                      // data.importo = parseFloat(data.importo / 100).toFixed(2);
                      // var importoDaPagare = parseFloat(data.importo / 100).toFixed(2);
                      // console.log(importoDaPagare)
                      return (
                        <>
                          {parseInt(data.numeroRata) === rataDapagare + 1 ? (
                            <tr
                              onClick={() => {
                                var rowSanzione = JSON.parse(
                                  sessionStorage.getItem("rowSanzione")
                                );
                                this.detailSanzioneService.getDetailRata(
                                  rowSanzione.id,
                                  (result) => {
                                    result.data.rate.map((valore) => {
                                      if (valore.id === data.id) {
                                        // this.state.paga.importoNetto =
                                        //   parseFloat(valore.importo)
                                        this.state.importoDasalvareIDRata =
                                          parseFloat(valore.importo / 100);
                                        // this.setState({importoNetto :  parseFloat(valore.importo)})
                                        this.state.paga.importoNetto =
                                          this.state.importoDasalvareIDRata;
                                        this.state.importoRataInferioreAImportoRata =
                                          valore.importo;
                                        // this.state.paga.codiceTx = "";
                                        this.state.paga.numeroRata = `${parseInt(
                                          data.numeroRata
                                        )}`;

                                        // console.log(this.state.paga)
                                        // console.log(data.id);

                                        this.state.importoRataInferioreAImportoRata =
                                          this.state.importoRataInferioreAImportoRata
                                            .toString()
                                            .replace(",", "");
                                        if (
                                          parseFloat(
                                            this.state.paga.importoNetto * 100
                                          ) <
                                          parseFloat(
                                            this.state
                                              .importoRataInferioreAImportoRata
                                          )
                                        ) {
                                          this.setState({
                                            importoInferiroDellaSanzioneDiUnPagamento: true,
                                          });
                                        } else {
                                          if (
                                            this.state.paga.codiceTx &&
                                            this.state.paga.dataContabile &&
                                            this.state.paga.note &&
                                            this.state.paga.tipoPagamento &&
                                            this.state.paga.importoNetto
                                          ) {
                                            this.setState({
                                              importoInferiroDellaSanzioneDiUnPagamento: false,
                                            });
                                          }
                                        }

                                        this.setState({
                                          seIlPagamentoDerivaDaUnaRata: false,
                                          statoSingolaRata: data.stato,
                                          showModalRateDaPagare: false,
                                          showModalPaga: true,
                                        });
                                      }
                                    });
                                  }
                                );

                                // this.state.paga.importoNetto = this.state.importoDasalvareIDRata
                              }}
                              className="table-warning text-center"
                            >
                              <td>{data.numeroRata}</td>
                              <td>
                                {data.importo.toString().replace(".", ",")}€
                              </td>
                              <td>
                                {/* {new Date(
                                  data.dataScandenza
                                ).toLocaleDateString()} */}
                                {this.dataScadenzaCorrerra}
                              </td>
                              {/* <td>{data.stato}</td> */}
                            </tr>
                          ) : (
                            <tr
                              onClick={() => {
                                if (data.stato === "pagata") {
                                  this.detailSanzioneService.dettaglioDiUnPagameto(
                                    this.state.sanzione.numeroSanzione,
                                    data.id,
                                    (result) => {
                                      if (result.status === 200) {
                                        this.setState({ paga: result.data });

                                        // console.log(result.data);
                                      } else {
                                        // console.log("errorrrrrre");
                                      }
                                    }
                                  );

                                  this.setState({
                                    showModalPaga: true,
                                    showModalRateDaPagare: false,
                                    statoSingolaRata: data.stato,
                                  });
                                }
                              }}
                              className={
                                data.stato === "pagata"
                                  ? " table-success text-center"
                                  : "table-danger text-center"
                              }
                            >
                              <td>{data.numeroRata}</td>
                              {/* <td>{data.importo + "00"/ 100} €</td> */}
                              <td>
                                € {data.importo.toString().replace(".", ",")}
                              </td>
                              <td>
                                {/* {new Date(
                                  data.dataScandenza
                                ).toLocaleDateString()} */}
                                {this.dataScadenzaCorrerra}
                              </td>
                              {/* <td>{data.stato}</td> */}
                            </tr>
                          )}
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.AnnullaPagaRata.bind(this)}
            >
              Annulla
            </Button>
            {this.state.rata.scaduta === true ? <Button
              variant="primary"
              className="text-left"
              onClick={ ()=>{
                // console.log("simone");
                this.detailSanzioneService.attoIngiuntivo(this.state.sanzione,this.state.sanzione.idSanzione, (result)=>{
                  // console.log(result);
                  if(result.data=== "Ingiunzione creata."){
                    toast.success("Ingiunzione creata");
                    this.props.history.push("/home");
                  }else{
                    toast.error("Ingiunzione non creata");
                  }
                  this.setState({modalShowattoIngiuntivo:false})
                })
              }}
            >
              Atto Ingiuntivo
            </Button>:""}
            
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  onSuccessGetDetailSanzione(result) {
    let body = result;
    if(body.sanzioni.noteTrasgressore === null) body.sanzioni.noteTrasgressore = "";
    this.setState({
      sanzione: body.sanzioni,
      listaStatiTo: result.listaStatiTo,
      listaSpacchettatiIntero: result.spacchettatoDTO.listaSpacchettatiIntero,
      listaSpacchettati: result.spacchettatoDTO.listaSpacchettati,
      listaSpacchettatiRidotto: result.spacchettatoDTO.listaSpacchettatiRidotto,
      speseProcedimento: result.spacchettatoDTO.speseProcedimento,
    });

    // console.log(this.state.sanzione.numeroSanzione);

    // this.setState({
    //   disableInput: this.state.sanzione.anagraficaStati.nomeStato != "Caricato",
    // });
    // this.setState(
    //   (this.state.sanzione.isverbaleFattoABordo=
    //     this.state.sanzione.isVerbaleConsegnatoABordo)
    // );
    this.setState({ disableInput: true });
    // if (this.state.sanzione.anagraficaTrasgressore.dataDiNascita)
    //   this.state.sanzione.anagraficaTrasgressore.dataDiNascita = moment(
    //     this.state.sanzione.anagraficaTrasgressore.dataDiNascita
    //   ).format("DD/MM/YYYY");
    // if (this.state.sanzione.anagraficaPotestaTrasgressore.dataDiNascita)
    //   this.state.sanzione.anagraficaPotestaTrasgressore.dataDiNascita = moment(
    //     this.state.sanzione.anagraficaPotestaTrasgressore.dataDiNascita
    //   ).format("DD/MM/YYYY");
    if (this.state.sanzione.anagraficaTrasgressore.dataRilascioDocumento)
      this.state.sanzione.anagraficaTrasgressore.dataRilascioDocumento = moment(
        this.state.sanzione.anagraficaTrasgressore.dataRilascioDocumento
      ).format("DD/MM/YYYY");
    this.state.sanctionEmissionDate = this.state.sanzione.dataDiEmissione;
    this.state.sanzione.dataDiEmissione = moment(
      this.state.sanzione.dataDiEmissione
    ).format("DD/MM/YYYY HH:mm");
    // if (this.state.sanzione.anagraficaPotestaTrasgressore)
    //   this.state.sanzione.anagraficaPotestaTrasgressore.dataDiNascita = moment(
    //     this.state.sanzione.anagraficaPotestaTrasgressore.dataDiNascita
    //   ).format("DD/MM/YYYY");
    if (this.state.sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento)
      this.state.sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento =
        moment(
          this.state.sanzione.anagraficaPotestaTrasgressore
            .dataRilascioDocumento
        ).format("DD/MM/YYYY");

    if (
      this.state.sanzione.anagraficaPotestaTrasgressore
        .dataRilascioDocumento === 0
    )
      this.state.sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento =
        "";

    if (this.state.sanzione.anagraficaTrasgressore.codiceFiscale) {
      this.detailSanzioneService.getRecidivo(
        this.state.sanzione.anagraficaTrasgressore.codiceFiscale,
        (result) => {
          this.setState({ recidivo: result.data });
          //  console.log(i);
          // console.debug(result.data.nSanz.toString());
          // this.state.recidivo = {
          //   nome: result.data.nome,
          //   cognome: result.data.cognome,
          //   cf: result.data.cf,
          //   nSanz: result.data.nSanz,
          // };
          if (result.data.listaDiDettaglioSanzioni == null) {
          } else {
            result.data.map((val) => {
              val.listaDiDettaglioSanzioni.map((val1) => {
                this.state.recidivo.listaDiDettaglioSanzioni = [
                  ...this.state.recidivo.listaDiDettaglioSanzioni,
                  {
                    numSanzione: val1.numSanzione,
                    dataEmissione: val1.dataEmissione,
                    statoSanzione: val1.statoSanzione,
                    idSanzione: val1.idSanzione,
                  },
                ];
              });
            });
          }
          // if(parseInt( ) < 1){

          //   this.setState({ buttonRecidivi:true})
          // }else{
          //   this.setState({ buttonRecidivi:false})

          // }
          // console.log(this.state.recidivo);
          this.state.recidivo.map((val) => {
            // console.log(val.nSanz);
            // this.state.valoreProv = parseInt(val.nSanz)
            this.setState({ valoreProv: parseInt(val.nSanz) });
          });
        }
      );
    }else{
      this.detailSanzioneService.getRecidivoById(
        this.state.sanzione.anagraficaTrasgressore.idAnagraficaTrasgressore,
        (result) => {
          this.setState({ recidivo: result.data });

          if (result.data.listaDiDettaglioSanzioni == null) {
          } else {
            result.data.map((val) => {
              val.listaDiDettaglioSanzioni.map((val1) => {
                this.state.recidivo.listaDiDettaglioSanzioni = [
                  ...this.state.recidivo.listaDiDettaglioSanzioni,
                  {
                    numSanzione: val1.numSanzione,
                    dataEmissione: val1.dataEmissione,
                    statoSanzione: val1.statoSanzione,
                    idSanzione: val1.idSanzione,
                  },
                ];
              });
            });
          }

          this.state.recidivo.map((val) => {
            this.setState({ valoreProv: parseInt(val.nSanz) });
          });
        }
      );

    }

    if (this.state.sanzione.anagraficaTrasgressore.dataRilascioDocumento === 0)
      this.state.sanzione.anagraficaTrasgressore.dataRilascioDocumento = "";

    if (this.state.sanzione.anagraficaTrasgressore.isMinorenne === 0)
      this.state.sanzione.anagraficaTrasgressore.isMinorenne = false;
    else this.state.sanzione.anagraficaTrasgressore.isMinorenne = true;

    if (this.state.sanzione.isverbaleFattoABordo === 0)
      this.state.sanzione.isverbaleFattoABordo = false;
    else this.state.sanzione.isverbaleFattoABordo = true;

    this.setState({ sanzione: this.state.sanzione });
    // this.setState({
    //   nuovoImportoRavvedimentoOperoso: this.state.sanzione.importo / 100,
    // });

    // console.log(this.state.sanzione.isverbaleFattoABordo);

    this.detailSanzioneService = new DetailSanzioneService();
    this.detailSanzioneService.getListStatiSanzione(
      this.state.sanzione.idSanzione,
      this.onSuccessGetStatiSanzione.bind(this)
    );

    // this.detailSanzioneService.scontrinoSanzionePDF(
    //   this.state.sanzione.numeroSanzione,
    //   (result) => {
    //     // console.log(result);
    //     // this.fileBase64 = "";
    //     if (result.status === 200) {
    //       this.state.fileBase64 = `${result.data}`;
    //       this.setState({ fileBase64: `${result.data}` });
    //       // console.log(result.data);
    //     } else {
    //       // toast.error("File non disponible");
    //     }
    //   }
    // );
    // console.log(result.anagraficaStati.nomeStato);
    var diff = calculateTimeDifferenceTwoDates(
      new Date(),
      moment(this.state.sanctionEmissionDate).toDate()
    );
    this.state.giorniAllaScadenza = parseInt(diff);
    this.state.isReduced5Days = this.state.giorniAllaScadenza <= 5
    this.state.isReduced60Days = !this.state.isReduced5Days && this.state.giorniAllaScadenza <= 60

    //if (this.state.sanzione.anagraficaTrasgressore.isMinorenne === false) {
      if (
        this.state.sanzione.anagraficaTrasgressore.nome &&
        this.state.sanzione.anagraficaTrasgressore.cognome &&
        this.state.sanzione.anagraficaTrasgressore.inidirizzoDiResidenza &&
        this.state.sanzione.anagraficaTrasgressore.comuneDiResidenza
      ) {
        this.setState({ buttonValidaSanzione: false });
      }
     else {
      if (
        this.state.sanzione.anagraficaTrasgressore.nome &&
        this.state.sanzione.anagraficaTrasgressore.cognome &&
        this.state.sanzione.anagraficaPotestaTrasgressore.nome &&
        this.state.sanzione.anagraficaPotestaTrasgressore.cognome &&
        this.state.sanzione.anagraficaPotestaTrasgressore
          .inidirizzoDiResidenza &&
        this.state.sanzione.anagraficaPotestaTrasgressore
          .provinciaDiResidenza &&
        this.state.sanzione.anagraficaPotestaTrasgressore.comuneDiResidenza
      ) {
        this.setState({ buttonValidaSanzione: false });
      }
    }

    this.setState({
      nuovoImportoRavvedimentoOperoso:
        this.state.isReduced5Days
        ? (this.state.listaSpacchettatiRidotto[0].valore / 100).toFixed(2).toString().replace(".", ",")
        : (
          this.state.isReduced60Days
          ? (this.state.listaSpacchettati[0].valore / 100).toFixed(2).toString().replace(".", ",")
          : (this.state.listaSpacchettatiIntero[0].valore / 100).toFixed(2).toString().replace(".", ",")
        )
    });
  }

  onSuccessGetStatiSanzione(result) {
    // if (result.length > 0) {
    //   for (let i = 0; i < result.length; i++) {
    //     result[i].dataOperazione = moment(result[i].dataOperazione).format(
    //       "DD/MM/YYYY"
    //     );
    //   }
    // }

    this.setState({ statiSanzione: result });
    this.setState({ loading: false });
  }

  backHome() {
    this.props.history.push("/home");
  }

  renderPartStoricoStatiSanzione() {
    if (this.state.statiSanzione && this.state.statiSanzione.length > 0) {
      return this.state.statiSanzione.map((stati, index) => {
        // console.log(stati);
        if (index < 3) {
          const {
            operazione,
            motivazioneOperazione,
            dataOperazione,
            matricola,
          } = stati;

          this.minuti =
            new Date(dataOperazione).getMinutes() < 10
              ? "0" + new Date(dataOperazione).getMinutes()
              : new Date(dataOperazione).getMinutes();
          // console.log(this.minuti);

          // console.log(dataOperazione);

          this.giornoCorretto =
            new Date(dataOperazione).getDate() < 9
              ? "0" + new Date(dataOperazione).getDate()
              : new Date(dataOperazione).getDate();
          this.meseCorretto =
            new Date(dataOperazione).getMonth() + 1 < 9
              ? "0" + (new Date(dataOperazione).getMonth() + 1)
              : new Date(dataOperazione).getMonth() + 1;

          this.dataStato =
            this.giornoCorretto +
            "/" +
            this.meseCorretto +
            "/" +
            new Date(dataOperazione).getFullYear();
          this.oraCambioStato =
            new Date(dataOperazione).getHours() + ":" + this.minuti;
          return (
            <>
              <li className="w-auto p-3 text-center">
                {" "}
                <time datetime={this.dataStato}>
                  {this.dataStato}
                  <br />
                  {this.oraCambioStato} <br /> <strong>{matricola}</strong>
                </time>{" "}
                <span className="text-center">
                  <br></br>
                  <strong>{operazione}</strong> {motivazioneOperazione}
                  {/* <p>{ this.oraCambioStato}</p> */}
                </span>
              </li>
            </>
          );
        }
      });
    } else {
      return <tr> Dati sugli stati della sanzione non disponibili.</tr>;
    }
  }
  renderAllStoricoStatiSanzione() {
    if (this.state.statiSanzione && this.state.statiSanzione.length > 0) {
      return this.state.statiSanzione.map((stati, index) => {
        // console.log(stati);
        const { operazione, motivazioneOperazione, dataOperazione, matricola } =
          stati;

        this.minutiStorico =
          new Date(dataOperazione).getMinutes() < 10
            ? "0" + new Date(dataOperazione).getMinutes()
            : new Date(dataOperazione).getMinutes();

        this.giornoCorretto =
          new Date(dataOperazione).getDate() < 9
            ? "0" + new Date(dataOperazione).getDate()
            : new Date(dataOperazione).getDate();
        this.meseCorretto =
          new Date(dataOperazione).getMonth() + 1 < 9
            ? "0" + (new Date(dataOperazione).getMonth() + 1)
            : new Date(dataOperazione).getMonth() + 1;

        this.dataStato =
          this.giornoCorretto +
          "/" +
          this.meseCorretto +
          "/" +
          new Date(dataOperazione).getFullYear();

        this.oraCambioStato =
          new Date(dataOperazione).getHours() + ":" + this.minutiStorico;

        return (
          <li className="w-auto p-3 text-center">
            {" "}
            <time datetime={this.dataStato}>
              {this.dataStato} <br />
              {this.oraCambioStato}
              <br /> <strong>{matricola}</strong>
            </time>{" "}
            <span>
              <br></br>
              <strong>{operazione}</strong> {motivazioneOperazione}{" "}
            </span>
          </li>
        );
      });
    } else {
      return <tr> Dati sugli stati della sanzione non disponibili.</tr>;
    }
  }

  showModalAgliAttiScrittoDifensivo(event) {
    this.state.idStatoPassagio = parseInt(event.target.id);
    this.setState({ showModalAgliAttiScrittoDifensivo: true });
  }
  showModalAgliAttiScrittoDifensivoAnnulla() {
    this.state.noteAgliAtti = "";
    this.setState({
      showModalAgliAttiScrittoDifensivo: false,
      agliAttiScrittoDifensivo: true,
    });
  }

  confermaAgliAttiScrittoDifensivo() {
    // console.log(this.state.noteAgliAtti);

    this.detailSanzioneService.AgliAttiPerLoscrittoDifensivo(
      this.state.sanzione,
      this.state.noteAgliAtti,
      this.state.sanzione.idSanzione,
      this.state.idStatoPassagio,
      this.onsuccessModificaSanzione.bind(this)
    );

    this.setState({ showModalAgliAttiScrittoDifensivo: false });
  }

  onChangeAgliAttiScrittoDifensivo(event) {
    this.state.noteAgliAtti = event.target.value;
    this.setState({ noteAgliAtti: event.target.value });
    if (this.state.noteAgliAtti.toString().length < 5) {
      this.setState({ agliAttiScrittoDifensivo: true });
    } else {
      this.setState({ agliAttiScrittoDifensivo: false });
    }
  }

  modalAgliAttiScrittoDifensivo() {
    return (
      <>
        <Modal size="lg" show={this.state.showModalAgliAttiScrittoDifensivo}>
          <Modal.Header>
            <Modal.Title>Conferma Agli Atti</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="col">
              <label>Note</label>
              <textarea
                className="form-control"
                type="area"
                placeholder="Agli atti (minimo 5 caratteri)"
                value={this.state.scrittoDifensivo.scrittoDifensivo}
                onChange={this.onChangeAgliAttiScrittoDifensivo.bind(this)}
              ></textarea>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <>
              <Button
                variant="primary"
                // disabled={this.state.fileSizeError}
                onClick={this.confermaAgliAttiScrittoDifensivo.bind(this)}
                disabled={this.state.agliAttiScrittoDifensivo}
              >
                Conferma
              </Button>
              <Button
                variant="secondary"
                onClick={this.showModalAgliAttiScrittoDifensivoAnnulla.bind(
                  this
                )}
              >
                Annulla
              </Button>
            </>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  modalAttoIngiuntivo(){
    return <>
          <Modal size="sm" show={this.state.modalShowattoIngiuntivo}>
          <Modal.Header>
            <Modal.Title>Conferma Atto Ingiuntivo</Modal.Title>
          </Modal.Header>
          {/* <Modal.Body> */}
            {/* <div className="col">
              <label>Note</label>
              <textarea
                className="form-control"
                type="area"
                placeholder="Agli atti (minimo 5 caratteri)"
                value={this.state.scrittoDifensivo.scrittoDifensivo}
                onChange={this.onChangeAgliAttiScrittoDifensivo.bind(this)}
              ></textarea>
            </div> */}
            {/* Conferma Atto Ingiuntivo
          </Modal.Body> */}
          <Modal.Footer>
              <Button
                variant="primary"
                // disabled={this.state.fileSizeError}
                onClick={
                  ()=>{
                    // console.log("simone");
                    this.detailSanzioneService.attoIngiuntivo(this.state.sanzione,this.state.sanzione.idSanzione, (result)=>{
                      // console.log(result);
                      if(result.data=== "Ingiunzione creata."){
                        toast.success("Ingiunzione creata");
                        this.props.history.push("/home");
                      }else{
                        toast.error("Ingiunzione non creata");
                      }
                      this.setState({modalShowattoIngiuntivo:false})
                    })
                  }
                }
                // disabled={this.state.agliAttiScrittoDifensivo}
              >
                Conferma
              </Button>
              <Button
                variant="secondary"
                onClick={()=> {
                  this.setState({
                    modalShowattoIngiuntivo:false
                  })
                }}
              >
                Annulla
              </Button>
          </Modal.Footer>
        </Modal>
    </> 
  }

  showBottonScrittoDifensivo() {
    return (
      <>
        <div className="row">
          {/* <div className="col d-flex justify-content-center">
            <button
              type="button"
              // disabled={this.state.disableInput}
              onClick={this.showModalSbloccaSanzione.bind(this)}
              className="btn btn-primary"
            >
              Sblocca Sanzione
            </button>
          </div> */}
          <div className="col d-flex justify-content-around">
            {this.state.listaStatiTo.map((valori) => {
              if (valori.nomeStato === "Agli Atti") {
                return(
                <button
                  type="button"
                  // disabled={this.state.disableInput}
                  id={valori.idStato}
                  onClick={this.showModalAgliAttiScrittoDifensivo.bind(this)}
                  className="btn btn-primary"
                >
                  Agli Atti
                </button>
                );
              }
              if(valori.nomeStato === "Validato"){
                return(
                  <button
                  type="button"
                  id={valori.idStato}
                  disabled={this.state.buttonValidaSanzione}
                  onClick={this.modalScrittoToValidataShowHandler.bind(this)}
                  className="btn btn-primary"
                >
                  Valida Sanzione
                </button>
                )
               }
            })}
            <button
              type="button"
              // disabled={this.state.disableInput}
              className="btn btn-primary"
              // onClick={this.showModalGestioneAllegatiAggiungiScritto.bind(this)}
              onClick={() => {
                // alert("Funzionalita in sviluppo . . .");
                this.setState({modalShowattoIngiuntivo:true})
              }}
            >
              Atto Ingiuntivo
            </button>
          </div>
          {/* <div className="col d-flex justify-content-center">
            <button
              type="button"
              // disabled={this.state.disableInput}
              onClick={() => alert("Funzionalita in sviluppo")}
              className="btn btn-primary"
            >
              Scarica Allegati
            </button>
          </div> */}
        </div>
      </>
    );
  }

  showSbloccaSanzione() {
    return (
      <>
        <div className="row">
          <div className="col d-flex justify-content-center">
            <button
              type="button"
              // disabled={this.state.disableInput}
              onClick={this.showModalSbloccaSanzione.bind(this)}
              className="btn btn-primary"
            >
              Sblocca Sanzione
            </button>
          </div>
        </div>
      </>
    );
  }

  showModalSbloccaSanzione() {
    this.setState({ showModalSbloccaSanzione: true });
  }

  AnnulaSbloccaSanzione() {
    this.setState({ showModalSbloccaSanzione: false });
  }

  ConfermaSbloccaSanzione() {
    // this.state.sanzione.anagraficaStati.nomeStato = "Caricato";
    this.detailSanzioneService.SbloccaSaznione(
      this.state.sanzione,
      this.state.sanzione.anagraficaStati.nomeStato,
      "Sbloccata",
      this.onsuccessModificaSanzione.bind(this)
    );
    // this.state.showModalSbloccaSanzione = false;
    this.setState({ showModalSbloccaSanzione: false });
  }

  modalSbloccaSanzione() {
    return (
      <>
        <Modal size="sm" show={this.state.showModalSbloccaSanzione}>
          <Modal.Header>
            <Modal.Title>Sblocca Sanzione</Modal.Title>
          </Modal.Header>
          <Modal.Body></Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.AnnulaSbloccaSanzione.bind(this)}
            >
              Annulla
            </Button>
            <Button
              variant="primary"
              onClick={this.ConfermaSbloccaSanzione.bind(this)}
              //   disabled={this.state.buttonCreaSanzione}
            >
              Sblocca sanzione
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  AnnullaRateizzaSanzione() {
    this.state.sommaDiTuttiGliImportiRata = 0;
    this.state.statosingoloImporto = [];
    this.state.creaRata.SpeseIncassoRata = "";
    this.state.creaRata.numeroDiRata = 0;
    this.setState({
      showModalRateizzaSanzione: false,
      creaRata: this.state.creaRata,
      rateizzaButton: true,
      errorNumeroRata: false,
      tableRata: [],
      SpeseIncassoRata: "",
      calcolaRata: true,
      resetRateizzaButton: true,
    });
  }
  ConfermaRateizzaSanzione() {
    // console.log(this.creaRateizza)
    this.state.tableRata.map((rata) => {
      rata.spesaIncassoRata = parseFloat(this.state.creaRata.SpeseIncassoRata);

      var importointero = rata.importo.toString().replace(".", "");

      if (
        rata.importo.toString().includes(".") ||
        rata.importo.toString().includes(",")
      ) {
        rata.importo = parseFloat(importointero);
      } else {
        rata.importo = parseFloat(importointero * 100);
      }

      // console.log(rata.importo);
      // if (importointero.toString().length === 2) {
      //   rata.importo = parseInt(importointero + "00");
      // } else {
      //   rata.importo = parseInt(importointero);
      // }
    });
    // console.log(this.state.tableRata);
    this.creaRateizza = {
      numeroSanzione: this.state.sanzione.numeroSanzione,
      rate: this.state.tableRata,
    };
    // console.log(this.creaRateizza);

    this.detailSanzioneService.creaRateizza(
      this.creaRateizza,
      this.state.sanzione.idSanzione,
      this.state.idStatoPassagio,
      (result) => {
        if (result) {
          toast.success(result, {
            position: toast.POSITION.TOP_RIGHT,
          });
          window.location.reload();
        } else {
          toast.error(result, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      }
    );
    // this.state.sommaDiTuttiGliImportiRata = 0;
    // let sommaRateSenzaSpese = 0;
    // let importo =  parseFloat(this.state.sanzione.importo) / 100;
    // this.state.tableRata.map((rata, index) => {
    //   this.importo = parseFloat(rata.importo) + this.state.sommaDiTuttiGliImportiRata;
    //   this.state.sommaDiTuttiGliImportiRata =
    //     parseFloat(rata.importo) + this.state.sommaDiTuttiGliImportiRata;
    //   sommaRateSenzaSpese = sommaRateSenzaSpese + (parseFloat(rata.importo) - parseFloat(this.state.creaRata.SpeseIncassoRata ))
    // });
    // if(sommaRateSenzaSpese === importo){
    //   this.setState({rateizzaButton:false})
    // }else{
    //   this.setState({rateizzaButton:true})
    // }
    this.state.tableRata = [];
    this.state.creaRata.SpeseIncassoRata = "";
    this.setState({
      showModalRateizzaSanzione: false,
      creaRata: this.state.creaRata,
      rateizzaButton: false,
      errorNumeroRata: false,
      calcolaRata: true,
      resetRateizzaButton: true,
    });
  }
  showModalRateizzaSanzione(event) {
    this.state.idStatoPassagio = parseInt(event.target.id);
    this.setState({ showModalRateizzaSanzione: true });
  }

  optionNumeroRate() {
    const nuemroRate = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];

    return (
      <>
        {nuemroRate.map((numero) => {
          return <option value={numero}>{numero}</option>;
        })}
      </>
    );
  }

  selectNumeroRate(event) {
    this.state.creaRata.numeroDiRata = event.target.value;
    this.setState({
      creaRata: this.state.creaRata,
      rateizzaButton: false,
      errorNumeroRata: false,
    });
    //LAVORO
    this.state.statosingoloImporto = [];
    this.state.tableRata = [];
    this.state.importoDaSalvarestate = [];
    var diff = calculateTimeDifferenceTwoDates(
      new Date(),
      moment(this.state.sanctionEmissionDate).toDate()
    );

    this.importo =
      this.state.isReduced5Days
        ? this.state.listaSpacchettatiRidotto[0].valore / 100
        : (
          this.state.isReduced60Days
          ? this.state.listaSpacchettati[0].valore / 100
          : this.state.listaSpacchettatiIntero[0] / 100
        )
    // console.log(this.importo / event.target.value > 20);
    if (this.importo / event.target.value < 20) {
      this.setState({
        errorNumeroRata: true,
        rateizzaButton: true,
        resetRateizzaButton: true,
      });
      this.state.resetRateizzaButton = true;
      this.state.rateizzaButton = true;
      this.state.calcolaRata = true;
    }
    const nuemroRate = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
    let giornoRata = new Date();
    nuemroRate.slice(0, parseInt(event.target.value)).map((rata, index) => {
      // index === 0 ? giornoRata : giornoRata.setDate(giornoRata.getDate() + 30)
      if (index === 0) {
        this.scadenzaPagamento = giornoRata;
        giornoRata.setDate(giornoRata.getMonth() + 1);
      } else {
        this.scadenzaPagamento = giornoRata.setDate(giornoRata.getDate() + 30);
        this.scadenzaPagamento = giornoRata.setMonth(giornoRata.getMonth() + (index));
      }
      this.state.tableRata = [
        ...this.state.tableRata,
        {
          numeroRata: `${index + 1}`,
          // importo: (this.importo / parseInt(event.target.value)).toFixed(2),
          importo: "",
          stato: "daPagare",
          dataScandenza: `${getFormatOraInputFirstaddMont(new Date(), (index + 1))}`,
          // new Date(this.scadenzaPagamento).getDate() +
          // "/" +
          // (new Date(this.scadenzaPagamento).getMonth() + 1) +
          // "/" +
          // new Date(this.scadenzaPagamento).getFullYear(),
        },
      ];
      // }
    });
    this.state.sommaDiTuttiGliImportiRata = 0;
    this.state.tableRata.map((rata, index) => {
      this.state.sommaDiTuttiGliImportiRata =
        parseFloat(rata.importo) + this.state.sommaDiTuttiGliImportiRata;
    });

    this.state.tableRata.map((numerorata, index) => {
      this.state.statosingoloImporto = [
        ...this.state.statosingoloImporto,
        {
          nueroRata: false,
        },
      ];
    });

    this.importo = parseFloat(this.state.sanzione.importo) / 100;
    if (this.state.sommaDiTuttiGliImportiRata === this.importo) {
      this.setState({ rateizzaButton: false });
    } else {
      this.setState({ rateizzaButton: true });
    }

    // console.log(this.state.tableRata);

    // console.log(event.target.value)
  }
  importoInCentesimiIncassoRata(event) {
    event.preventDefault();
    this.state.creaRata.SpeseIncassoRata = event.target.value;
    this.setState({ creaRata: this.state.creaRata }); //, rateizzaButton:true

    this.state.tableRata.map((importoDaSalvare) => {
      this.state.importoDaSalvarestate = [
        ...this.state.importoDaSalvarestate,
        {
          importoSalvato: importoDaSalvare.importo,
        },
      ];
    });
    // console.log(this.state.importoDaSalvarestate);
    // if (event.target.value === 0 || event.target.value === "") {
    //   this.state.creaRata.SpeseIncassoRata = 0;
    // }

    this.state.tableRata.map((rata, index) => {
      // console.log("siongola rata " + rata.importo);
      // console.log(this.state.importoDaSalvarestate);

      this.valore =
        // parseFloat(rata.importo) +
        parseFloat(this.state.importoDaSalvarestate[index].importoSalvato) +
        parseFloat(this.state.creaRata.SpeseIncassoRata);
      // console.log(
      //   parseFloat(
      //     rata.importo + this.state.creaRata.SpeseIncassoRata
      //   )
      // );

      this.setState({
        sommaDiTuttiGliImportiRata: this.state.sommaDiTuttiGliImportiRata,
      });
      return (
        <>
          {event.target.value === ""
            ? (rata.importo =
                this.state.importoDaSalvarestate[index].importoSalvato)
            : (rata.importo = this.valore.toFixed(2))}
          {/* {rata.importo = this.valore.toFixed(2)} */}
        </>
      );
      // }
    });

    // if (this.importo + ) {
    //   this.setState({ rateizzaButton: false });
    // } else {
    //   this.setState({ rateizzaButton: true });
    // }
  }

  inputImportoRata(event) {
    // console.log(event.target);
    // this.importo = this.state.giorniAllaScadenza < 5
    // ? this.state.sanzione.anagraficaTipologiaSanzione.importoRidotto
    //     .toString()
    //     .substring(
    //       0,
    //       this.state.sanzione.anagraficaTipologiaSanzione.importoRidotto.toString()
    //         .length - 1
    //     )
    // : this.state.sanzione.importo / 100;
    this.importo = this.state.sanzione.importo / 100;
    var indiceArrray = parseInt(event.target.id);
    // console.log(this.state.tableRata);
    this.state.tableRata[indiceArrray - 1].importo = event.target.value;
    this.setState({ tableRata: this.state.tableRata });
    this.state.sommaDiTuttiGliImportiRata = 0;
    this.state.tableRata.map((rata, index) => {
      this.state.sommaDiTuttiGliImportiRata =
        parseFloat(rata.importo) + this.state.sommaDiTuttiGliImportiRata;
    });
    this.state.statosingoloImporto.map((val) => {
      if (val.state === true) {
        this.setState({ rateizzaButton: true });
      } else {
        if (this.state.sommaDiTuttiGliImportiRata >= this.importo) {
          this.setState({ rateizzaButton: false });
        }
      }
    });

    if (this.state.tableRata[indiceArrray - 1].importo < 20.0) {
      this.state.statosingoloImporto[indiceArrray - 1].stato = true;
      this.setState({ rateizzaButton: true });
    } else {
      this.state.statosingoloImporto[indiceArrray - 1].stato = false;
    }
    // console.log(this.state.statosingoloImporto);

    this.importo = parseFloat(this.state.sanzione.importo) / 100;

    this.state.tableRata.map((rata, index) => {
      if (index === 0) {
        this.count = 0;
      }
      if (this.count === 0) {
        if (rata.importo < 20.0) {
          this.count = 1;
          this.setState({ rateizzaButton: true });
        }
      }
    });

    // const valore = this.state.statosingoloImporto.map((val) => val.stato).indexOf(true);

    // console.log(valore);

    // if (this.state.sommaDiTuttiGliImportiRata >= this.importo) {
    //   this.setState({ rateizzaButton: false });
    // } else {
    //   this.setState({ rateizzaButton: true });
    // }

    // this.state.tableRata.map((importo) => {
    //   if(importo.importo < 20.0){
    //     this.setState({ rateizzaButton: true });
    //   }else {
    //     this.setState({ rateizzaButton: false });
    //   }
    // })
  }

  verbaleFattoAbbordoButton() {
    // this.componentWillUpdate();
    // this.setState(this.state.disableInput)

    if (this.state.buttonVerbaleFattoAbbordo) {
      // console.log("true");
      return (
        <>
          {this.state.sanzione.isverbaleFattoABordo ? (
            <ul class="list-group">
              <li class="list-group-item active text-center">
                Effettuato a bordo
              </li>{" "}
            </ul>
          ) : (
            <ul class="list-group">
              <li class="list-group-item text-center">
                Non Effettuato a bordo
              </li>{" "}
            </ul>
          )}

          {/* {this.state.sanzione.isverbaleFattoABordo === 0 ? <div class="badge badge-secondary"><p className="">Effetuato a bordo</p></div> : <div class="badge badge-secondary"><p>Non Effettuato a bordo</p></div>} */}

          {/* {this.state.sanzione.isverbaleFattoABordo === 0 ? <div class="border border-hidden rounded-pill primary text-center m-3" style={{backgroundColor:"#0b5ed7", color:"#fff"}} ><p>Effetuato a bordo</p></div> : <div class="border border-hidden rounded-pill text-center m-3"><p>Non Effettuato a bordo</p></div>} */}

          {/* <BootstrapSwitchButton
            disabled={true}
            checked={!this.state.sanzione.isverbaleFattoABordo}
            onlabel="Effettuato a bordo"
            offlabel="Non Effettuato a bordo"
            style="w-100 mx-1"
          /> */}
        </>
      );
    } else {
      // console.log("falso");
      return (
        <>
          <BootstrapSwitchButton
            disabled={false}
            checked={this.state.sanzione.isverbaleFattoABordo}
            onChange={this.changeVerbaleFattoABordo.bind(this)}
            onlabel="Effettuato a bordo"
            offlabel="Non Effettuato a bordo"
            style="w-100 mx-1"
          />
        </>
      );

      // return (
      //   <>
      //     <BootstrapSwitchButton
      //       onClick={(disabled) => {
      //         // this.setState({ isUserAdmin: checked });
      //         this.disaVerba = disabled;
      //         if(this.state.disableInput){
      //           this.disaVerba = true;
      //         }else{
      //           this.disaVerba= false;
      //         }
      //         // console.log("")
      //       }}
      //       disabled={this.disaVerba}
      //       checked={!this.state.sanzione.isVerbaleConsegnatoABordo}
      //       onlabel="Effettuato a bordo"
      //       offlabel="Non Effettuato a bordo"
      //       style="w-100 mx-1"
      //     />
      //   </>
      // );
    }
  }

  modalRateizzaSanzione() {
    return (
      <>
        <>
          <Modal size="lg" show={this.state.showModalRateizzaSanzione}>
            <Modal.Header>
              <h4>Rateizza Sanzione </h4>
              <Modal.Title>
                Importo totale:{" "}
                <u>
                  € {parseFloat(this.state.sanzione.importo / 100).toFixed(2)}
                </u>{" "}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <fieldset className="border p-2">
                {/* <legend className="w-auto" style={{ color: "#4e73df" }}></legend> */}
                <div className="row">
                  <div className="input-group mb-3">
                    <div className="col-sm-4">Numeri di Rata</div>
                    <div className="col-sm-8">
                      <Form.Control
                        as="select"
                        onChange={this.selectNumeroRate.bind(this)}
                      >
                        <option value={0}>Numero Rate</option>
                        {this.optionNumeroRate()}
                      </Form.Control>
                    </div>

                    <div className="container">
                      <br></br>
                      <table class="table table-bordered">
                        {this.state.tableRata.map((rata, index) => {
                          var indiceArrray = parseInt(rata.numeroRata);

                          // console.log(rata.dataScandenza);
                          getFormatOraInputFirst(rata.dataScandenza);
                          // this.giornoCorretta =
                          //   new Date(rata.dataScandenza).getDate() < 10
                          //     ? "0" + new Date(rata.dataScandenza).getDate()
                          //     : new Date(rata.dataScandenza).getDate();
                          // this.messeCorretto =
                          //   new Date(rata.dataScandenza).getMonth() + 2 < 10
                          //     ? "0" +
                          //       (new Date(rata.dataScandenza).getMonth() + index)
                          //     : new Date(rata.dataScandenza).getMonth() + index;
                          // this.anno = new Date(
                          //   rata.dataScandenza
                          // ).getFullYear();

                          // // console.log(this.meseCorretto);

                          // this.fullDate =
                          //   this.giornoCorretta +
                          //   "/" +
                          //   this.messeCorretto +
                          //   "/" +
                          //   this.anno;
                          return (
                            <>
                              {index === 0 ? (
                                <>
                                  <thead>
                                    <tr>
                                      <th scope="col" className="text-center">
                                        N° Rata
                                      </th>
                                      <th scope="col" className="text-center">
                                        Importo
                                      </th>
                                      <th scope="col" className="text-center">
                                        Data Rata
                                      </th>
                                    </tr>
                                  </thead>
                                </>
                              ) : (
                                ""
                              )}
                              <tbody>
                                <tr>
                                  <td className="text-center">
                                    {rata.numeroRata}
                                  </td>
                                  <td className="text-center">
                                    <div className="input-group">
                                      <div className="input-group-prepend">
                                        <span className="input-group-text">
                                          €
                                        </span>
                                      </div>
                                      <input
                                        id={rata.numeroRata}
                                        className="form-control"
                                        type="number"
                                        value={rata.importo}
                                        onChange={this.inputImportoRata.bind(
                                          this
                                        )}
                                        aria-label="Importo in euro"
                                      />
                                    </div>
                                    {/* {rata.importo < 20.0 ? (
                                      <p className="text-danger">
                                        {rata.importo}€
                                      </p>
                                    ) : (
                                      <p className="text-success">
                                        {rata.importo}€
                                      </p>
                                    )} */}
                                    {this.state.statosingoloImporto[
                                      indiceArrray - 1
                                    ].stato ? (
                                      <p className="text-danger">
                                        Importo inferiore a € 20.00
                                      </p>
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                  <td className="text-center">
                                    {/* {new Date(rata.dataScandenza).getDate() +
                                      "/" +
                                      new Date(rata.dataScandenza).getMonth() +
                                      "/" +
                                      new Date(
                                        rata.dataScandenza
                                      ).getFullYear()} */}
                                    {geDataFormat(rata.dataScandenza)}
                                  </td>
                                </tr>
                              </tbody>
                            </>
                          );
                        })}
                      </table>
                      {/* {this.state.sommaDiTuttiGliImportiRata ===
                      parseFloat(this.importo) ? (
                        <p className="text-center text-success">
                          {parseFloat(this.state.sommaDiTuttiGliImportiRata).toFixed(
                            2
                          )}
                          € / {parseFloat(this.importo).toFixed(2)}€{" "}
                        </p>
                      ) : this.state.sommaDiTuttiGliImportiRata === 0 ? (
                        <></>
                      ) : (
                        <p className="text-center text-danger">
                          {parseFloat(this.state.sommaDiTuttiGliImportiRata).toFixed(
                            2
                          )}
                          € / {parseFloat(this.importo).toFixed(2)}€{" "}
                        </p>
                      )} */}
                      {/* {this.state.sommaDiTuttiGliImportiRata === 0 ? "" : this.state.sommaDiTuttiGliImportiRata === parseFloat(this.importo) ?  (""): ( */}

                      {this.state.creaRata.numeroDiRata <= 0 ? (
                        ""
                      ) : this.state.rateizzaButton ? (
                        <p className="text-center text-danger">
                          L'importo delle rate non corrisponde all'importo
                          sanzione
                        </p>
                      ) : (
                        ""
                      )}
                      {/* {this.state.sommaDiTuttiGliImportiRata ===
                      parseFloat(this.importo) ?  (""): (
                        <p className="text-center text-danger">
                          L'importo delle rate non corrisponde all'importo sanzione
                        </p>
                      )} */}
                      {/* {this.state.sommaDiTuttiGliImportiRata}<p>{parseFloat(this.state.sanzione.importo) / 100}</p> */}
                    </div>
                  </div>
                </div>
                <br></br>
                {/* <div className="row">
                  <div className="input-group mb-3">
                    <div className="col-sm-4">Spese Incasso Rata</div>
                    <div className="input-group-prepend">
                      <span className="input-group-text">€</span>
                    </div>
                    <input
                      className="form-control"
                      type="number"
                      // placeholder={"20.00 / 3.99 Formato Valori"}
                      value={this.state.creaRata.SpeseIncassoRata}
                      onChange={this.importoInCentesimiIncassoRata.bind(this)}
                      // onFocus={this.calcolaRataIncenteimi.bind(this)}
                      aria-label="Importo in euro"
                    />
                  </div>
                </div> */}
              </fieldset>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.AnnullaRateizzaSanzione.bind(this)}
              >
                Annulla
              </Button>
              <Button
                variant="primary"
                onClick={this.ConfermaRateizzaSanzione.bind(this)}
                disabled={this.state.rateizzaButton}
              >
                Rateizza Sanzione
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      </>
    );
  }

  modalStoricoPagamentiHandler(){
    this.setState((prevState)=>({showModalStoricoPagamenti:!prevState.showModalStoricoPagamenti}));
  }

  downloadRicevuta(id,idPagamento){
    let numeroSanzione = this.state.sanzione.numeroSanzione;
    this.detailSanzioneService.getRicevutaPagamento(id,idPagamento,(result)=>{
      const element = document.createElement('a')
      element.href = `data:application/pdf;base64,${result}`
      element.download = `attestato_pagamento_${numeroSanzione}_${idPagamento}.pdf`
      document.body.appendChild(element)
      element.click()
    },
    (error)=>{
      toast.error("Errore Download, Riprova piu tardi")
    })

  }

  checkAnagrafica(){

    if(this.state.disableInput){
      return true
    }

    if(this.state.sanzione.anagraficaTrasgressore.isMinorenne){
        if(
        !this.nameRegex.test(this.state.sanzione.anagraficaTrasgressore.nome)
        || !this.nameRegex.test(this.state.sanzione.anagraficaTrasgressore.cognome)
        || !(this.state.sanzione.anagraficaTrasgressore.sesso === "F" || this.state.sanzione.anagraficaTrasgressore.sesso === "M")
        || this.state.sanzione.localita.length < 2
        || !this.nameRegex.test(this.state.sanzione.anagraficaPotestaTrasgressore.nome)
        || !this.nameRegex.test(this.state.sanzione.anagraficaPotestaTrasgressore.cognome)
        || this.state.sanzione.anagraficaPotestaTrasgressore.comuneDiResidenza.length === 0
        || this.state.sanzione.anagraficaPotestaTrasgressore.inidirizzoDiResidenza.length === 0
        || this.state.sanzione.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza.length === 0
      ) {
        return true;
      }

      return false

    }else{
        if(
        !this.nameRegex.test(this.state.sanzione.anagraficaTrasgressore.nome)
        || !this.nameRegex.test(this.state.sanzione.anagraficaTrasgressore.cognome)
        || !(this.state.sanzione.anagraficaTrasgressore.sesso === "F" || this.state.sanzione.anagraficaTrasgressore.sesso === "M")
        || this.state.sanzione.anagraficaTrasgressore.comuneDiResidenza.length === 0
        || this.state.sanzione.anagraficaTrasgressore.inidirizzoDiResidenza.length === 0
        || this.state.sanzione.anagraficaTrasgressore.inidirizzoNumeroDiResidenza.length === 0
        || this.state.sanzione.localita.length < 2
      ) {
        return true;
      }

      return false
    }

    
  }

  modalStoricoPagamenti(){
    return (
      <>
        <Modal size="xl" show={this.state.showModalStoricoPagamenti}>
          <Modal.Header>
            <Modal.Title>Storico Pagamenti</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
            {this.state.storicoPagamenti.length > 0 
            ? (<Table 
              size="sm"
              responsive >
              <thead className="text-center">
                <tr>
                  <th>Data Contabile</th>
                  <th>Tipo Pagamento</th>
                  <th>Importo Netto</th>
                  <th>Codice Transazione</th>
                  <th>Note</th>
                  <th>Download</th>
                </tr>

              </thead>
              <tbody>
              {this.state.storicoPagamenti.map((pagamento)=>{
              return <tr className="text-center">
                <td>{geDataFormat(pagamento.dataContabile)}</td>
                <td>{pagamento.tipoPagamento}</td>
                <td>€ {(pagamento.importoNetto / 100).toLocaleString('it-IT',{minimumFractionDigits:2})}</td>
                <td>{pagamento.codiceTx}</td>
                <td>{pagamento.note}</td>
                <td>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16" onClick={()=>{
                  this.downloadRicevuta(this.state.sanzione.idSanzione,pagamento.idPagamento)}}>
                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                </svg>
                </td>
              </tr>
            })}
              </tbody>
            </Table>)
            : <p>Non ci sono Pagamenti</p>}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.modalStoricoPagamentiHandler.bind(this)}
            >
              Annulla
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }


  showButton() {
    var stato = this.state.sanzione.anagraficaStati.nomeStato;
    
    // if (stato === "Ravvedimento Operoso") {
    //   return (
    //     <>
    //       {" "}
    //       <div className="col d-flex justify-content-center">
    //         <button
    //           type="button"
    //           className="btn btn-primary"
    //           onClick={this.paga.bind(this)}
    //         >
    //           Paga Sanzione
    //         </button>
    //       </div>
    //     </>
    //   );
    // }

    return (
      <div className="row">
        {this.state.sanzione.anagraficaStati.nomeStato === "Caricato" || this.state.sanzione.anagraficaStati.nomeStato === "Ingiunzione" ? (
          <div className="col d-flex justify-content-center">
            <button
              type="button"
              disabled={this.checkAnagrafica() || this.state.disableInput}
              onClick={this.modificaSanzione.bind(this)}
              className="btn btn-primary"
            >
              Modifica Sanzione
            </button>
          </div>
        ) : (
          ""
        )}

        {/* {this.state.sanzione.anagraficaStati.nomeStato === "Caricato" ? ( */}
        {this.state.listaStatiTo.map((valori) => {
          if (valori.nomeStato === "Validato") {
            return (
              <>
                {this.state.buttonValidaSanzione === false &&
                this.state.sanzione.anagraficaStati.nomeStato === "Caricato" ? (
                  <div className="col d-flex justify-content-center">
                    <button
                      type="button"
                      id={valori.idStato}
                      disabled={this.state.buttonValidaSanzione}
                      onClick={this.cambioStato.bind(this)}
                      className="btn btn-primary"
                    >
                      Valida Sanzione
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </>
            );
          }
        })}
        <>
          {this.state.listaStatiTo.map((valori) => {
            if (valori.nomeStato === "Rateizzato") {
              return (
                <>
                  {this.state.sanzione.importo / 100 >= 100 &&
                  this.state.sanzione.anagraficaStati.nomeStato ===
                    "Validato" ? (
                    <div className="col d-flex justify-content-center">
                      <button
                        type="button"
                        id={valori.idStato}
                        className="btn btn-primary"
                        onClick={this.showModalRateizzaSanzione.bind(this)}
                      >
                        Rateizza Sanzione
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                </>
              );
            }
          })}
        </>

        {this.state.listaStatiTo.map((valori) => {
          if (valori.nomeStato === "Pagata") {
            return (
              <>
                {this.state.sanzione.anagraficaStati.nomeStato !== "Ingiunzione" && <div className="col d-flex justify-content-center">
                  <button
                    type="button"
                    id={valori.idStato}
                    className="btn btn-primary"
                    onClick={this.paga.bind(this)}
                  >
                    Paga Sanzione
                  </button>
                </div>}
              </>
            );
          }
        })}
        <>
          {this.state.listaStatiTo.map((valori) => {
            if (valori.nomeStato === "Scritto Difensivo") {
              return (
                <>
                  <div className="col d-flex justify-content-center">
                    <button
                      type="button"
                      id={valori.idStato}
                      className="btn btn-primary"
                      onClick={this.showScrittoDifensivo.bind(this)}
                    >
                      Scritto Difensivo
                    </button>
                  </div>
                </>
              );
            }
          })}

          {this.state.listaStatiTo.map((valori, index) => {
            if (valori.nomeStato === "Ravvedimento Operoso") {
              return (
                <>
                  <div className="col d-flex justify-content-center">
                    <button
                      id={valori.idStato}
                      type="button"
                      className="btn btn-primary"
                      onClick={this.ravvedimentoOperoso.bind(this)}
                    >
                      Ravvedimento Operoso
                    </button>
                  </div>
                </>
              );
            }
          })}

          {this.state.listaStatiTo.map((valori, index) => {
            if (index === 0) {
              this.valoreTrovato = 1;
            }
            if (this.valoreTrovato === 1) {
              if (
                valori.nomeStato === "Bloccata" ||
                valori.nomeStato === "Agli Atti" ||
                valori.nomeStato === "Annullata"
              ) {
                this.valoreTrovato = 0;
                return (
                  <>
                    <div className="col d-flex justify-content-center">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={this.altreAzioniSanzione.bind(this)}
                      >
                        Altre Azioni
                      </button>
                    </div>
                  </>
                );
              }
            }
          })}
        </>
      </div>
    );
  }

  showDatiAnagraficaPatriaPotesta() {
    const template = "xx/xx/xxxx";
    if (this.state.sanzione.anagraficaTrasgressore.isMinorenne) {
      return (
        <fieldset className="border p-2">
          <legend className="w-auto" style={{ color: "#4e73df" }}>
            Anagrafica Patria Potestà Trasgressore
          </legend>
          <br></br>
          <br></br>
          <div className="row">
            <div className="col-sm-4">
              Nome <small className="text-danger">*</small>
            </div>
            <div className="col-sm-8">
              <input
                className="form-control"
                type="text"
                value={this.state.sanzione.anagraficaPotestaTrasgressore.nome}
                onChange={this.changeTextSanzioneNameP.bind(this)}
                disabled={this.state.disableInput}
              ></input>
            </div>
          </div>
          <br></br>
          <div className="row">
            <div className="col-sm-4">
              Cognome <small className="text-danger">*</small>
            </div>
            <div className="col-sm-8">
              <input
                className="form-control"
                type="text"
                value={
                  this.state.sanzione.anagraficaPotestaTrasgressore.cognome
                }
                onChange={this.changeTextSanzioneCognomeP.bind(this)}
                disabled={this.state.disableInput}
              ></input>
            </div>
          </div>
          <br></br>
          <div className="row">
            <div className="col-sm-4">
              Sesso <small className="text-danger">*</small>
            </div>
            <div className="col-sm-8">
              <select
                onChange={(event) => this.sexSelectorHandler(event, true)}
                className="form-select"
                disabled={this.state.disableInput}
                value={this.findIndexFromSexList(this.state.sanzione.anagraficaPotestaTrasgressore.sesso)}
              >
                <option key="empty_inspector" value={""}></option>
                {
                  this.state.sexList.map((sex,index) => {
                    return <option key={"inspector_"+index} value={index}>{sex}</option>
                  })
                }
              </select>
            </div>
          </div>
          <br></br>
          <div className="row">
            {this.state.testoModificaSanzione != "Abilita Modifiche" ? (
              <>
                <div className="col-sm-4">Data di nascita</div>
                <div className="col-sm-8">
                  <input
                    className="form-control"
                    type="date"
                    value={
                      getFormatOraInput(this.state.sanzione.anagraficaPotestaTrasgressore
                        .dataDiNascita)
                    }
                    placeholder="GG/MM/YYYY"
                    onChange={this.changeTextSanzioneDataNascitaP.bind(this)}
                    disabled={this.state.disableInput}
                  ></input>
                  {/* {this.state.errorDataDiNascitaTrasgessorePatria ? (
                    <>
                      <small className="text-danger">
                        Il formato della data è GG/MM/YYYY
                      </small>
                    </>
                  ) : (
                    <></>
                  )}
                  {} */}

                  {/* <ReactInput
	value={this.state.sanzione.anagraficaPotestaTrasgressore
    .dataDiNascita}
	// value={this.state.sanzione.anagraficaPotestaTrasgressore
  //   .dataDiNascita}
	onChange={ this.changeTextSanzioneDataNascitaP.bind(this) }
	// onChange={ this.changeTextSanzioneDataNascitaP.bind(this) }
	format={ templateFormatter(template) }
	parse={ templateParser(template, parseDigit) }
  disabled={this.state.disableInput}
  className="form-control"/> */}
                </div>
              </>
            ) : (
              <>
                {" "}
                <div className="col-sm-4">Data di nascita</div>
                <div className="col-sm-8">
                  <input
                    className="form-control"
                    type="date"
                    value={
                      getFormatOraInput(this.state.sanzione.anagraficaPotestaTrasgressore
                        .dataDiNascita)
                    }
                    placeholder="GG/MM/YYYY"
                    onChange={this.changeTextSanzioneDataNascitaP.bind(this)}
                    disabled={this.state.disableInput}
                  ></input>
                  {/* {this.state.errorDataDiNascitaTrasgessorePatria ? (
                    <>
                      <small className="text-danger">
                        Il formato della data è GG/MM/YYYY
                      </small>
                    </>
                  ) : (
                    <></>
                  )} */}
                  {/* <ReactInput
	value={this.state.sanzione.anagraficaPotestaTrasgressore
    .dataDiNascita}
	onChange={ this.changeTextSanzioneDataNascitaP.bind(this) }
	format={ templateFormatter(template) }
	parse={ templateParser(template, parseDigit) }
  disabled={this.state.disableInput}
  className="form-control"/> */}
                </div>
              </>
            )}
          </div>
          <br/>
          <div className="row">
            <div className="col-sm-4">C.F.</div>
            <div className="col-sm-8">
              <input
                className="form-control"
                type="text"
                value={
                  this.state.sanzione.anagraficaPotestaTrasgressore
                    .codiceFiscale
                }
                maxLength="16"
                onChange={this.changeTextSanzioneCFP.bind(this)}
                disabled={this.state.disableInput}
              ></input>
              {this.state.errorCFTrasgessorePatria ? (
                <>
                  <small className="text-danger">
                    Il formato del Codice Fiscale è sbagliato
                  </small>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
          <br></br>
          <div className="row">
            <div className="col-sm-4">Luogo di nascita</div>
            <div className="col-sm-8">
              <input
                className="form-control"
                type="text"
                value={
                  this.state.sanzione.anagraficaPotestaTrasgressore
                    .luogoDiNascita
                }
                onChange={this.changeTextSanzioneLuogoNascitaP.bind(this)}
                disabled={this.state.disableInput}
              ></input>
            </div>
          </div>
          <br></br>

          <fieldset className="border p-2">
            <legend className="w-auto">Documento di riconoscimento</legend>
            <div className="row">
              <div className="col-sm-2">N° doc.</div>
              <div className="col-sm-3">
                <input
                  className="form-control"
                  type="text"
                  value={
                    this.state.sanzione.anagraficaPotestaTrasgressore
                      .numeroDocumento
                  }
                  maxLength="20"
                  onChange={this.changeTextSanzioneNDocP.bind(this)}
                  disabled={this.state.disableInput}
                ></input>
              </div>
              {this.state.testoModificaSanzione != "Abilita Modifiche" ? (
                <>
                  <div className="col-sm-2">data rilascio</div>
                  <div className="col-sm-5">
                    <input
                      className="form-control"
                      type="date"
                      value={
                        getFormatOraInput(this.state.sanzione.anagraficaPotestaTrasgressore
                          .dataRilascioDocumento)
                      }
                      placeholder="GG/MM/YYYY"
                      onChange={this.changeTextSanzioneDataDocP.bind(this)}
                      disabled={this.state.disableInput}
                    ></input>
                    {/* {this.state.errorDataDiRilascioTrasgessorePatria ? (
                      <>
                        <small className="text-danger">
                          Il formato della data è GG/MM/YYYY
                        </small>
                      </>
                    ) : (
                      <></>
                    )} */}
                  </div>
                </>
              ) : (
                <>
                  <div className="col-sm-2">data rilascio</div>
                  <div className="col-sm-5">
                    <input
                      className="form-control"
                      type="date"
                      value={
                        getFormatOraInput(this.state.sanzione.anagraficaPotestaTrasgressore
                          .dataRilascioDocumento)
                      }
                      placeholder="GG/MM/YYYY"
                      onChange={this.changeTextSanzioneDataDocP.bind(this)}
                      disabled={this.state.disableInput}
                    ></input>
                    {/* {this.state.errorDataDiRilascioTrasgessorePatria ? (
                      <>
                        <small className="text-danger">
                          Il formato della data è GG/MM/YYYY
                        </small>
                      </>
                    ) : (
                      <></>
                    )} */}
                  </div>
                </>
              )}
            </div>
            <br></br>
            <div className="row">
              <div className="col-sm-2">rilasciato da</div>
              <div className="col-sm-4">
                <input
                  className="form-control"
                  type="text"
                  value={
                    this.state.sanzione.anagraficaPotestaTrasgressore
                      .enteRilascioDocumento
                  }
                  onChange={this.changeTextSanzioneEnteRilascioDocP.bind(this)}
                  disabled={this.state.disableInput}
                ></input>
              </div>
              <div className="col-sm-2">tipo documento</div>
              <div className="col-sm-4">
                <input
                  className="form-control"
                  type="text"
                  value={
                    this.state.sanzione.anagraficaPotestaTrasgressore.tipoDocumento
                  }
                  onChange={this.changeTextTipoDocumentoP.bind(this)}
                  disabled={this.state.disableInput}
                ></input>
              </div>

            </div>
          </fieldset>
          <br></br>
          <fieldset className="border p-2">
            <legend className="w-auto">Residenza</legend>
            <div className="row">
              <div className="col-sm-2">
                Comune <small className="text-danger">*</small>
              </div>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="text"
                  value={
                    this.state.sanzione.anagraficaPotestaTrasgressore
                      .comuneDiResidenza
                  }
                  onChange={this.changeTextSanzioneComuneResidenzaP.bind(this)}
                  disabled={this.state.disableInput}
                ></input>
              </div>
            </div>
            <br></br>
            <div className="row">
              <div className="col-sm-2">
                indirizzo <small className="text-danger">*</small>
              </div>
              <div className="col-sm-10">
                <input
                  className="form-control"
                  type="text"
                  value={
                    this.state.sanzione.anagraficaPotestaTrasgressore
                      .inidirizzoDiResidenza
                  }
                  onChange={this.changeTextSanzioneIndirizzoResidenzaP.bind(
                    this
                  )}
                  disabled={this.state.disableInput}
                ></input>
              </div>
            </div>
            <br></br>
            <div className="row">
              <div className="col-sm-1">
                n° <small className="text-danger">*</small>
              </div>
              <div className="col-sm-3">
                <input
                  className="form-control"
                  type="text"
                  value={
                    this.state.sanzione.anagraficaPotestaTrasgressore
                      .inidirizzoNumeroDiResidenza
                  }
                  onChange={this.changeTextSanzioneNumIndirizzoResidenzaP.bind(
                    this
                  )}
                  disabled={this.state.disableInput}
                ></input>
              </div>
              <div className="col-sm-1">
                Cap
              </div>
              <div className="col-sm-2">
                <input
                  className="form-control"
                  type="text"
                  value={
                    this.state.sanzione.anagraficaPotestaTrasgressore
                      .capDiResidenza
                  }
                  onChange={this.changeTextSanzioneCapResidenzaP.bind(this)}
                  disabled={this.state.disableInput}
                ></input>
              </div>
              <div className="col-sm-2">
                Provincia
              </div>
              <div className="col-sm-3">
                <input
                  className="form-control"
                  type="text"
                  value={
                    this.state.sanzione.anagraficaPotestaTrasgressore
                      .provinciaDiResidenza
                  }
                  onChange={this.changeTextSanzionePRResidenzaP.bind(this)}
                  disabled={this.state.disableInput}
                ></input>
              </div>
            </div>
          </fieldset>
          <br></br>
        </fieldset>
      );
    }
  }

  modificaBottoneSanzione() {
    this.setState((prevState) => ({
      disableInput: !prevState.disableInput,
    }));

    if (this.state.testoModificaSanzione === "Abilita Modifiche") {
      this.setState({
        testoModificaSanzione: "Disabilita Modifiche",
        buttonVerbaleFattoAbbordo: false,
        buttonValidaSanzione: true,
      });
      // this.setState({})
    } else {
      var rowSanzione = JSON.parse(sessionStorage.getItem("rowSanzione"));
      this.detailSanzioneService.getDetailSanzione(
        rowSanzione.id,
        this.onSuccessGetDetailSanzione.bind(this)
      );
      this.setState({
        testoModificaSanzione: "Abilita Modifiche",
        buttonVerbaleFattoAbbordo: true,
      });
      // this.setState({})
    }
  }

  bottoneModificaSanzione() {
    return (
      <>
        <button
          type="button"
          onClick={this.modificaBottoneSanzione.bind(this)}
          className={
            this.state.testoModificaSanzione === "Abilita Modifiche"
              ? "btn btn-primary"
              : "btn btn-secondary"
          }
        >
          {this.state.testoModificaSanzione}
        </button>
      </>
    );
  }

  chiudiScheda() {
    sessionStorage.removeItem("ListaSaznioniRecidivo");
    this.setState({ showModalSanzioniRecidivo: false });
  }

  tabbellaSanzioniRecidivo() {
    var moment = require("moment");
    this.state.recidivo.map((val) => {
      // console.log(val.nSanz);
      this.state.valoreProv = parseInt(val.nSanz);
    });
    return (
      <>
        <Modal size="lg" show={this.state.showModalSanzioniRecidivo}>
          <Modal.Header>
            <Modal.Title>Scheda Sanzioni Recidivo </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.recidivo.map((val, index) => {
              return (
                <>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">Numero Sanzione</th>
                        <th scope="col">Data Emissione</th>
                        <th scope="col">stato</th>
                      </tr>
                    </thead>
                    <tbody>
                      {val.listaDiDettaglioSanzioni.map((val1) => {
                        return (
                          <>
                            <>
                              <tr
                                onClick={() => {
                                  const valoriSaznionePush = {
                                    id: val1.idSanzione,
                                    statoSanzione: "Recidivo",
                                    idSaznioneProvenienza:
                                      this.state.sanzione.idSanzione,
                                    numeroSanzioneProvenienza:
                                      this.state.sanzione.numeroSanzione,
                                  };

                                  this.detailSanzioneService.getDetailSanzione(
                                    val1.idSanzione,
                                    this.onSuccessGetDetailSanzione.bind(this)
                                  );

                                  sessionStorage.removeItem("rowSanzione");
                                  sessionStorage.setItem(
                                    "rowSanzione",
                                    JSON.stringify(valoriSaznionePush)
                                  );
                                  // this.props.history.push("/detailSanzione");
                                  this.setState({
                                    showModalSanzioniRecidivo: false,
                                  });
                                }}
                              >
                                <td>{val1.numSanzione}</td>
                                <td>{geDataFormat(val1.dataEmissione)}</td>
                                <td>{val1.statoSanzione}</td>
                              </tr>
                            </>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </>
              );
            })}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.chiudiScheda.bind(this)}>
              Chiudi scheda Sanzioni
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }



  render() {
    // console.log(this.state.listaStatiTo);
    // console.log(this.state.recidivo.nSanz);

    var diff = calculateTimeDifferenceTwoDates(
      new Date(),
      moment(this.state.sanctionEmissionDate).toDate()
    );
    var giorniAllaScadenza = parseInt(diff);
    var isReduced5Days = giorniAllaScadenza <= 5
    var isReduced60Days = !isReduced5Days && giorniAllaScadenza <= 60

    // giorniAllaScadenza < 5 ? this.state.paga.importoNetto = this.state.sanzione.anagraficaTipologiaSanzione.importoRidotto / 100 : this.state.paga.importoNetto = this.state.sanzione.importo / 100

    // const params = new URLSearchParams(this.props.history);
    // console.log(params)

    // console.log(storia);
    // console.log(window.history.previous);
    // console.log(window.location);
    // var referrer = document.referrer;
    // console.log(this.props.history.location.pathname);

    this.rowSanzionePrev = JSON.parse(sessionStorage.getItem("rowSanzione"));
    if (
      this.rowSanzionePrev.idSaznioneProvenienza &&
      this.rowSanzionePrev.numeroSanzioneProvenienza
    ) {
      this.state.rowSanzionePrev.idSaznioneProvenienza =
        this.rowSanzionePrev.idSaznioneProvenienza;
      this.state.rowSanzionePrev.numeroSanzioneProvenienza =
        this.rowSanzionePrev.numeroSanzioneProvenienza;

      this.rowPrecednete = {
        statoSanzione: this.state.path,
        id: this.state.rowSanzionePrev.idSaznioneProvenienza,
        idSaznioneProvenienza: 0,
        numeroSanzioneProvenienza: "",
      };
    }
    //verificare l'id della sanzione per le ingiunzioni
    // console.log(rowSanzione.statoSanzione);

    const template = "xx/xx/xxxx";
    let content = this.state.loading ? (
      <LoadSpinner />
    ) : (
      <div id="wrapper">
        <Menucustom />
        <div className="container-fluid">
          <br />
          <br />
          <div className="d-sm-flex align-items-center justify-content-between mb-6">
            <div>
            <h1 className="h1 mb-2 text-gray-800">
              Dettaglio sanzione<br></br>
              {/* PATH */}
              {this.state.rowSanzionePrev.idSaznioneProvenienza === 0 &&
              this.state.rowSanzionePrev.numeroSanzioneProvenienza === "" ? (
                <small
                  style={{ fontSize: "14px" }}
                  className="mb-2 text-gray-800"
                >
                  Sanzioni &#8594;{" "}
                  <a
                    onClick={() => {
                      window.location.href = this.state.pathPush;
                    }}
                  >
                    <u>{this.state.path}</u>
                  </a>{" "}
                  &#8594; Dettaglio Sanzione
                </small>
              ) : (
                <small
                  style={{ fontSize: "14px" }}
                  className="mb-2 text-gray-800"
                >
                  Sanzioni &#8594;{" "}
                  <a
                    onClick={() => {
                      sessionStorage.removeItem("rowSanzione");
                      sessionStorage.setItem(
                        "rowSanzione",
                        JSON.stringify(this.rowPrecednete)
                      );
                      this.detailSanzioneService.getDetailSanzione(
                        this.rowPrecednete.id,
                        this.onSuccessGetDetailSanzione.bind(this)
                      );
                      this.setState({ rowSanzionePrev: this.rowPrecednete });
                    }}
                  >
                    <u>
                      {this.state.rowSanzionePrev.numeroSanzioneProvenienza}
                    </u>
                  </a>{" "}
                  &#8594; Dettaglio Sanzione
                </small>
              )}
            </h1>
            </div>
            <div className="d-flex flex-column gap-3 mr-lg-0 mr-1">

            <div className="d-flex flex-column flex-lg-row gap-lg-2 gap-1">
                {
                  <Button
                  size="sm"
                  variant="warning"
                  onClick={this.showModalTentativiPagamento.bind(this)}>
                    <i className="fas fa-credit-card text-white"></i> Tentativi di pagamento online
                  </Button>
                }
                {this.gestioneTentativiModal()}
                {/* {this.state.path === "In Lavorazione" && 
                <Button
                size="sm"
                variant="warning"
                disabled
                onClick={this.inviaMail.bind(this)}
                >
                  <i className="fas  fa-mail-bulk text-white"></i> Invio Mail
                </Button>
                } */}
                {this.state.sanzione.anagraficaStati.nomeStato === "Pagata" &&
                <Button
                size="sm"
                variant="warning"
                onClick={()=>{
                  let rowSanzione = JSON.parse(sessionStorage.getItem("rowSanzione"));
                    this.detailSanzioneService.getStoricoPagamenti(rowSanzione.id,
                      (result)=>{
                        if(result){
                          this.setState({storicoPagamenti:[...result]})
                          this.modalStoricoPagamentiHandler()
                        }
                      },
                      (error)=>{
                        toast.error("Errore nel caricare lo storico pagamenti, Riprova")
                        this.setState({storicoPagamenti:[]})
                      })
                }
                }
                >
                  <i className="fas  fa-history text-white"></i>  Storico Pagamenti
                </Button>
                }
                {/* <Button
                size="sm"
                variant="warning"
                disabled
                onClick={this.showModalBolletinoPostale.bind(this)}>
                  <i className="fas  fa-print text-white"></i> Stampa Bollettino
                </Button> */}
                {this.state.sanzione.anagraficaStati.nomeStato !== "Ravvedimento Operoso" &&
                <Button
                size="sm"
                variant="warning"
                onClick={(props) => {
                  // console.log(props.target.href);
                  this.detailSanzioneService.scontrinoSanzionePDF(
                    this.state.sanzione.numeroSanzione,
                    (result) => {
                      if (result.status === 200) {
                        this.state.fileBase64 = `${result.data}`;
                        this.setState({ fileBase64: `${result.data}` });
                        props.target.download =
                          this.state.sanzione.numeroSanzione + ".pdf";
                        props.target.title =
                          this.state.sanzione.numeroSanzione + ".pdf";
                        // props.target.href =
                        //   "data:application/" +
                        //   this.state.sanzione.numeroSanzione +
                        //   ".pdf;base64," +
                        //   this.state.fileBase64;
                        {
                          let a = document.createElement("a");
                          a.href =
                            "data:application/" +
                            this.state.sanzione.numeroSanzione +
                            ".pdf;base64," +
                            this.state.fileBase64;
                          a.download =
                            this.state.sanzione.numeroSanzione + ".pdf";
                          a.title = this.state.sanzione.numeroSanzione + ".pdf";
                          a.click();
                        }
                        // window.location.href = "data:application/" +
                        // this.state.sanzione.numeroSanzione +
                        // ".pdf;base64," +
                        // this.state.fileBase64;
                        // console.log(result.data);
                        // this.props.history.push("data:application/" +
                        //   this.state.sanzione.numeroSanzione +
                        //   ".pdf;base64," +
                        // this.state.fileBase64);
                      } else {
                        // toast.error("File non disponible");
                      }
                    }
                  );
                  // console.log(result.anagraficaStati.nomeStato);
                }}>
                  <i className="fas  fa-print text-white"></i> Stampa Sanzione
                </Button>
                }

              </div>
            <div className="row gap-2">
            {this.bollettinoPostale()}
            </div>
            </div>
            
          </div>

          <br></br>
          <div className="col">
            <div className="row">
              <div className="col">
                <div className="row">
                  <div className="col-sm-12">
                    <b> Numero Sanzione:</b>{" "}
                    {this.state.sanzione.numeroSanzione}
                  </div>
                </div>
                {/* <br></br> */}
                {/* <div className="row">
                  <div className="col-sm-12">
                    <b> Importo Sanzione: </b>
                    <NumberFormat
                      thousandsGroupStyle="thousand"
                      value={this.state.sanzione.importo / 100}
                      prefix="€"
                      decimalSeparator="."
                      displayType="text"
                      type="text"
                      thousandSeparator={true}
                      allowNegative={true}
                    />
                    <br></br>
                    <ul>
                      <li>simone</li>
                    </ul>
                  </div>
                </div> */}
                <br></br>
                <div className="row">
                  <div className="col-sm-12">
                    <b> Matricola Controllore:</b>{" "}
                    {this.state.sanzione.matricolaControllore}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-sm-12">
                    <b> Data Emissione Sanzione:</b>{" "}
                    {moment(this.state.sanctionEmissionDate).format("DD/MM/YYYY HH:mm")}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-sm-12">
                    <b> Data Notifica Sanzione:</b>{" "}
                    {this.state.sanzione.dataNotifica ?moment(this.state.sanzione.dataNotifica).format("DD/MM/YYYY HH:mm"):"N.D."}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-sm-12">
                    <b> Stato Sanzione:</b>{" "}
                    {this.state.sanzione.anagraficaStati.nomeStato}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-sm-12">
                    <b> Tipologia Sanzione:</b>{" "}
                    {
                      this.state.sanzione.anagraficaTipologiaSanzione
                        .nomeViolazione
                    }
                  </div>
                </div>
                <br/>
                <div className="row">
                  <div className="col-sm-12">
                    <b> Articolo violato:</b>{" "}
                    {
                      this.state.sanzione.anagraficaTipologiaSanzione
                        .normaDiRiferimento
                    }
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-sm-12">
                    <b> Località:</b>{" "}
                    {this.state.sanzione.localita}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-sm-12">
                    <b> Linea Mezzo:</b> {this.state.sanzione.lineaMezzo}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-sm-12">
                    <b> Rateizzato:</b>{" "}
                    {this.state.sanzione.anagraficaStati.nomeStato ===
                    "Rateizzato"
                      ? "SI"
                      : "NO"}
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-sm-12">
                    <button
                      className="btn btn-warning"
                      onClick={this.showModalGestioneAllegati.bind(this)}
                    >
                      <i className="fas fa-folder-open text-white"> </i>{" "}
                      Gestione Allegati
                    </button>
                  </div>
                </div>
                {this.gestioneAllegatiModal()}
                <br></br>
              </div>
              <div className="col">
                <div className="col">
                {this.state.sanzione.anagraficaStati.nomeStato !== "Pagata" && <fieldset className="border p-2">
                  {this.state.sanzione.anagraficaStati.nomeStato === "Ravvedimento Operoso" ? <>
                  <b>Composizione Importo Sanzione </b>
                    <br></br>
                    <br></br>
                    <ul>
                      <li>
                        <b>Importo Ravvedimendo Operoso:{" "}</b>
                        {/* <NumberFormat
                          thousandsGroupStyle="thousand"
                          value={0}
                          prefix="€"
                          decimalSeparator="."
                          displayType="text"
                          type="text"
                          thousandSeparator={true}
                          allowNegative={true}
                        /> */}
                        
                          <b>
                            € {(this.state.sanzione.importo / 100).toFixed(2)
                                  .toString()
                                  .replace(".", ",")}
                          </b>
                        
                        <br></br>
                        <br></br>
                      </li>
                      </ul>
                  </> : <>
                  <b>Composizione Importo Sanzione </b>
                    <br></br>
                    <br></br>
                    <ul>
                      {isReduced5Days || isReduced60Days// && this.state.sanzione.importoRidotto !== 0
                      ? (
                        <>
                          <li>
                            <b>
                            <s>Importo Sanzione Amm:
                              € {/*this.state.sanzione.anagraficaTipologiaSanzione.aggiungiPrezzoTratta
                                ?((this.state.sanzione.importo - this.state.sanzione.localita.importo)/100).toFixed(2).toString().replace(".", ",")
                                :(this.state.listaSpacchettatiIntero/100).toFixed(2).toString().replace(".", ",")*/
                                (this.state.listaSpacchettatiIntero[0].valore/100).toFixed(2).toString().replace(".", ",")}
                              </s>
                            </b>
                          </li>
                          {/*this.state.listaSpacchettatiIntero.map((spacchettato)=>{
                            if(spacchettato.descrizione === "SZING"){
                              return<></>
                            }
                            return (
                            <>
                              <li>
                                <s>{spacchettato.descrizione} :</s><b>{(spacchettato.valore / 100).toFixed(2).toString().replace(".", ",")} €</b>
                              </li>
                            </>
                            )
                          })*/}
                        </>
                      )
                      :(
                        <>
                          <li>
                            <b>
                            Importo Sanzione Amm:
                            € {/*this.state.sanzione.anagraficaTipologiaSanzione.aggiungiPrezzoTratta
                              ?((this.state.sanzione.importo - this.state.sanzione.localita.importo)/100).toFixed(2).toString().replace(".", ",")
                              :(this.state.sanzione.importo/100).toFixed(2).toString().replace(".", ",")*/
                              (this.state.listaSpacchettatiIntero[0].valore/100).toFixed(2).toString().replace(".", ",")}
                            </b>
                          </li>
                          {/*this.state.listaSpacchettatiIntero.map((spacchettato)=>{
                            if(spacchettato.descrizione === "SZING"){
                               return<></>
                              }
                            return (
                            <>
                              <li>
                                {spacchettato.descrizione} :<b>{(spacchettato.valore / 100).toFixed(2).toString().replace(".", ",")} €</b>
                              </li>
                            </>
                            )
                          })*/}
                        </>
                      )}
                      {/* Importo Ridotto */}
                      {/*this.state.sanzione.importoRidotto !== 0
                      ? (<>{giorniAllaScadenza > 5
                        ?(
                          <>
                            <li>
                              <s>
                                <b>Importo Ridotto:
                                {this.state.sanzione.anagraficaTipologiaSanzione.aggiungiPrezzoTratta
                                  ?((this.state.sanzione.importoRidotto - this.state.sanzione.localita.importo)/100).toFixed(2).toString().replace(".", ",")
                                  :(this.state.sanzione.importoRidotto/100).toFixed(2).toString().replace(".", ",")} €
                                </b>
                                <br/>
                                <small
                                className="font-small"
                                style={{ fontSize: "12px" }}
                              >
                                pagamento entro 5 giorni
                              </small>
                              </s>
                            </li>
                            {this.state.listaSpacchettatiRidotto.map((spacchettato)=>{
                              if(spacchettato.descrizione === "SZING"){
                                return<></> 
                              }
                              return(
                                <li>
                                  <s>{spacchettato.descrizione} :
                                    <b>{(spacchettato.valore / 100).toFixed(2).toString().replace(".", ",")} €</b>
                                  </s>
                                </li>
                              )
                            })}
                          </>
                        )
                      : (
                        <>
                          <li>
                            <b>
                            Importo Ridotto:
                            {this.state.sanzione.anagraficaTipologiaSanzione.aggiungiPrezzoTratta
                              ?((this.state.sanzione.importoRidotto - this.state.sanzione.localita.importo)/100).toFixed(2).toString().replace(".", ",")
                              :(this.state.sanzione.importoRidotto/100).toFixed(2).toString().replace(".", ",")} €
                            </b>
                            <br/>
                            <small
                              className="font-small"
                              style={{ fontSize: "12px" }}
                            >
                              pagamento entro 5 giorni
                            </small>
                          </li>
                          {this.state.listaSpacchettatiRidotto.map((spacchettato)=>{
                             if(spacchettato.descrizione === "SZING"){
                              return<></>
                            }
                              return(
                                <li>
                                  {spacchettato.descrizione} :
                                    <b>{(spacchettato.valore / 100).toFixed(2).toString().replace(".", ",")} €</b>
                                </li>
                              )
                            })}
                        </>
                      )}</>)
                    : (<></>)
                    */
                    isReduced5Days || !isReduced60Days
                    ?(
                      <>
                        <li>
                          <s>
                            <b>Importo Ridotto da 6° a 60° giorno:
                            € {(this.state.listaSpacchettati[0].valore/100).toFixed(2).toString().replace(".", ",")}
                            </b>
                            <br/>
                            <small
                            className="font-small"
                            style={{ fontSize: "12px" }}
                          >
                            pagamento da 6° a 60° giorno
                          </small>
                          </s>
                        </li>
                        {/*this.state.listaSpacchettatiRidotto.map((spacchettato)=>{
                          if(spacchettato.descrizione === "SZING"){
                            return<></> 
                          }
                          return(
                            <li>
                              <s>{spacchettato.descrizione} :
                                <b>{(spacchettato.valore / 100).toFixed(2).toString().replace(".", ",")} €</b>
                              </s>
                            </li>
                          )
                        })*/}
                      </>
                    )
                  : (
                    <>
                      <li>
                        <b>
                        Importo Ridotto da 6° a 60° giorno:
                        € {(this.state.listaSpacchettati[0].valore/100).toFixed(2).toString().replace(".", ",")}
                        </b>
                        <br/>
                        <small
                          className="font-small"
                          style={{ fontSize: "12px" }}
                        >
                          pagamento da 6° a 60° giorno
                        </small>
                      </li>
                      {/*this.state.listaSpacchettatiRidotto.map((spacchettato)=>{
                         if(spacchettato.descrizione === "SZING"){
                          return<></>
                        }
                          return(
                            <li>
                              {spacchettato.descrizione} :
                                <b>{(spacchettato.valore / 100).toFixed(2).toString().replace(".", ",")} €</b>
                            </li>
                          )
                        })*/}
                    </>
                  )}
                  {
                    !isReduced5Days
                    ?(
                      <>
                        <li>
                          <s>
                            <b>Importo Ridotto entro 5° giorno:
                            € {(this.state.listaSpacchettatiRidotto[0].valore/100).toFixed(2).toString().replace(".", ",")}
                            </b>
                            <br/>
                            <small
                            className="font-small"
                            style={{ fontSize: "12px" }}
                          >
                            pagamento entro 5° giorno
                          </small>
                          </s>
                        </li>
                        {/*this.state.listaSpacchettatiRidotto.map((spacchettato)=>{
                          if(spacchettato.descrizione === "SZING"){
                            return<></> 
                          }
                          return(
                            <li>
                              <s>{spacchettato.descrizione} :
                                <b>{(spacchettato.valore / 100).toFixed(2).toString().replace(".", ",")} €</b>
                              </s>
                            </li>
                          )
                        })*/}
                      </>
                    )
                  : (
                    <>
                      <li>
                        <b>
                        Importo Ridotto entro 5° giorno:
                        € {(this.state.listaSpacchettatiRidotto[0].valore/100).toFixed(2).toString().replace(".", ",")}
                        </b>
                        <br/>
                        <small
                          className="font-small"
                          style={{ fontSize: "12px" }}
                        >
                          pagamento entro 5° giorno
                        </small>
                      </li>
                      {/*this.state.listaSpacchettatiRidotto.map((spacchettato)=>{
                         if(spacchettato.descrizione === "SZING"){
                          return<></>
                        }
                          return(
                            <li>
                              {spacchettato.descrizione} :
                                <b>{(spacchettato.valore / 100).toFixed(2).toString().replace(".", ",")} €</b>
                            </li>
                          )
                        })*/}
                      </>
                    )
                  }
                  <br/>
                  {
                    <b>
                      Di cui spese procedurali pari a:
                      € {(this.state.speseProcedimento/100).toFixed(2).toString().replace(".", ",")}
                    </b>
                  }
                    </ul>
                    <hr></hr>
                    <div className="text-center">
                      {isReduced5Days ? (
                        <>
                          <b>Importo Sanzione da Pagare: </b>
                          {/* <NumberFormat
                            thousandsGroupStyle="thousand"
                            value={
                              this.state.sanzione.importoRidotto / 100
                            }
                            prefix="€"
                            decimalSeparator="."
                            displayType="text"
                            type="text"
                            thousandSeparator={true}
                            allowNegative={true}
                          /> */}
                          <b>
                            € {(this.state.listaSpacchettatiRidotto[0].valore / 100).toFixed(2)
                              .toString()
                              .replace(".", ",")}
                          </b>
                        </>
                      ) :
                      isReduced60Days ? (
                        <>
                          <b>Importo Sanzione da Pagare: </b>
                          {/* <NumberFormat
                            thousandsGroupStyle="thousand"
                            value={this.state.sanzione.importo / 100}
                            prefix="€"
                            decimalSeparator="."
                            displayType="text"
                            type="text"
                            thousandSeparator={true}
                            allowNegative={true}
                          /> */}
                          <b>
                            € {(this.state.listaSpacchettati[0].valore / 100).toFixed(2)
                              .toString()
                              .replace(".", ",")}
                          </b>
                        </>
                      ) : (
                        <>
                          <b>Importo Sanzione da Pagare: </b>
                          {/* <NumberFormat
                            thousandsGroupStyle="thousand"
                            value={this.state.sanzione.importo / 100}
                            prefix="€"
                            decimalSeparator="."
                            displayType="text"
                            type="text"
                            thousandSeparator={true}
                            allowNegative={true}
                          /> */}
                          <b>
                            € {(this.state.listaSpacchettatiIntero[0].valore / 100).toFixed(2)
                              .toString()
                              .replace(".", ",")}
                          </b>
                        </>
                      )}

                      <br></br>
                    </div></>}
                  </fieldset>}
                </div>
              </div>
              <div className="col-sm-6">
                <fieldset className="border p-2">
                  <legend className="w-auto" style={{ color: "#4e73df" }}>
                    &nbsp;&nbsp;Storico Stati Sanzione
                  </legend>
                  <br></br>
                  <ul className="events w-auto p-3">
                    {this.renderPartStoricoStatiSanzione()}
                  </ul>
                  <br></br>
                  <div className="d-sm-flex  justify-content-between mb-6">
                    <button
                      type="button"
                      className="btn btn-warning"
                      onClick={this.estendiStoricoSanzione.bind(this)}
                    >
                      <i className="fas  fa-history text-white"></i> Estendi
                      Storico
                    </button>
                  </div>
                </fieldset>
              </div>
            </div>
            <br></br>
            <fieldset className="border p-2">
              <legend className="" style={{ color: "#4e73df" }}>
                {/* w-auto */}
                <div className="row">
                  <div className="col">Anagrafica Utente</div>
                  <div className="col">
                    {this.state.sanzione.anagraficaStati.nomeStato === "Caricato" || this.state.sanzione.anagraficaStati.nomeStato === "Ingiunzione"
                      ? this.bottoneModificaSanzione(this)
                      : ""}
                  </div>
                  {this.state.valoreProv <= 1 ? (
                    ""
                  ) : (
                    <>
                      {/* {this.state.rowSanzionePrev.idSaznioneProvenienza === 0 &&
                      this.state.rowSanzionePrev.numeroSanzioneProvenienza ===
                        "" ? ( */}
                      <div className="col">
                        <i
                          onClick={() => {
                            if (
                              this.state.rowSanzionePrev
                                .idSaznioneProvenienza === 0
                            ) {
                              this.setState({
                                showModalSanzioniRecidivo: true,
                              });
                            } else {
                            }
                          }}
                        >
                          <img
                            src={R}
                            width={"25px"}
                            height={"25px"}
                            alt="Recidivi"
                          />
                        </i>
                      </div>
                      {/* ) : (<>
                        
                        </>)} */}
                    </>
                  )}
                </div>
              </legend>
              <br></br>
              <br></br>
              <div className="row">
                <div className="col-sm-4">
                  Nome <small className="text-danger">*</small>
                </div>
                <div className="col-sm-8">
                  <input
                    className="form-control"
                    type="text"
                    value={this.state.sanzione.anagraficaTrasgressore.nome}
                    onChange={this.changeTextSanzioneName.bind(this)}
                    disabled={this.state.disableInput}
                  ></input>
                </div>
              </div>
              <br></br>
              <div className="row">
                <div className="col-sm-4">
                  Cognome <small className="text-danger">*</small>
                </div>
                <div className="col-sm-8">
                  <input
                    className="form-control"
                    type="text"
                    value={this.state.sanzione.anagraficaTrasgressore.cognome}
                    onChange={this.changeTextSanzioneCognome.bind(this)}
                    disabled={this.state.disableInput}
                  ></input>
                </div>
              </div>
              <br></br>
              <div className="row">
                <div className="col-sm-4">
                  Sesso <small className="text-danger">*</small>
                </div>
                <div className="col-sm-8">
                  <select
                    onChange={(event) => this.sexSelectorHandler(event, false)}
                    className="form-select"
                    disabled={this.state.disableInput}
                    value={this.findIndexFromSexList(this.state.sanzione.anagraficaTrasgressore.sesso)}
                  >
                    <option key="empty_inspector" value={""}></option>
                    {
                      this.state.sexList.map((sex,index) => {
                        return <option key={"inspector_"+index} value={index}>{sex}</option>
                      })
                    }
                  </select>
                </div>
              </div>
              <br></br>
              <div className="row">
                {this.state.testoModificaSanzione != "Abilita Modifiche" ? (
                  <>
                    <div className="col-sm-4">Data di nascita <small className="text-danger">*</small></div>
                    <div className="col-sm-6">
                      <input
                        className="form-control"
                        type="date"
                        max={getFormatOraInput(new Date())}
                        value={
                          getFormatOraInput(this.state.sanzione.anagraficaTrasgressore
                            .dataDiNascita)
                        }
                        placeholder="GG/MM/YYYY"
                        onChange={this.changeTextSanzioneDataNascita.bind(this)}
                        disabled={this.state.disableInput}
                      ></input>
                      {/* {this.state.errorDataDiNascitaTrasgessore ? (
                        <>
                          <small className="text-danger">
                            Il formato della data è GG/MM/YYYY
                          </small>
                        </>
                      ) : (
                        <></>
                      )} */}
                      {/* <ReactInput
	value={this.state.sanzione.anagraficaTrasgressore
    .dataDiNascita}
	// value={this.state.sanzione.anagraficaPotestaTrasgressore
  //   .dataDiNascita}
	onChange={ this.changeTextSanzioneDataNascita.bind(this) }
	// onChange={ this.changeTextSanzioneDataNascitaP.bind(this) }
	format={ templateFormatter(template) }
	parse={ templateParser(template, parseDigit) }
  disabled={this.state.disableInput}
  className="form-control"/> */}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-sm-4">Data di nascita <small className="text-danger">*</small></div>
                    <div className="col-sm-6">
                      <input
                        className="form-control"
                        type="date"
                        max={getFormatOraInput(new Date())}
                        value={
                          getFormatOraInput(this.state.sanzione.anagraficaTrasgressore
                            .dataDiNascita)
                        }
                        onChange={this.changeTextSanzioneDataNascita.bind(this)}
                        disabled={this.state.disableInput}
                        placeholder="GG/MM/YYYY"
                      ></input>
                      {/* {this.state.errorDataDiNascitaTrasgessore ? (
                        <>
                          <small className="text-danger">
                            Il formato della data è GG/MM/YYYY
                          </small>
                        </>
                      ) : (
                        <></>
                      )} */}
                      {/* <ReactInput
	value={this.state.sanzione.anagraficaTrasgressore
    .dataDiNascita}
	// value={this.state.sanzione.anagraficaPotestaTrasgressore
  //   .dataDiNascita}
	onChange={ this.changeTextSanzioneDataNascita.bind(this) }
	// onChange={ this.changeTextSanzioneDataNascitaP.bind(this) }
	format={ templateFormatter(template) }
	parse={ templateParser(template, parseDigit) }
  disabled={this.state.disableInput}
  className="form-control"/> */}
                    </div>
                  </>
                )}

                <div className="col-sm-2">
                  {this.state.disableInput ? (
                    !this.state.sanzione.anagraficaTrasgressore.isMinorenne ? (
                      <ul class="list-group">
                        <li class="list-group-item active text-center">
                          Maggiorenne
                        </li>{" "}
                      </ul>
                    ) : (
                      <ul class="list-group">
                        <li class="list-group-item text-center">Minorenne</li>{" "}
                      </ul>
                    )
                  ) : (
                    <BootstrapSwitchButton
                      // disabled={this.state.disableInput}
                      disabled={false}
                      checked={
                        !this.state.sanzione.anagraficaTrasgressore.isMinorenne
                      }
                      onChange={this.changeIsMaggiorenne.bind(this)}
                      onlabel="Maggiorenne"
                      offlabel="Minorenne"
                      style="w-100 mx-1"
                    />
                  )}
                </div>
              </div>
              <br></br>
              <div className="row">
                <div className="col-sm-4">C.F.</div>
                <div className="col-sm-8">
                  <input
                    className="form-control"
                    type="text"
                    value={
                      this.state.sanzione.anagraficaTrasgressore.codiceFiscale
                    }
                    maxLength="16"
                    onChange={this.changeTextSanzioneCF.bind(this)}
                    disabled={this.state.disableInput}
                  ></input>
                  {this.state.errorCFTrasgessore ? (
                    <>
                      <small className="text-danger">
                        Il formato del Codice Fiscale è sbagliato
                      </small>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <br></br>
              <div className="row">
                <div className="col-sm-4">Luogo di nascita</div>
                <div className="col-sm-8">
                  <input
                    className="form-control"
                    type="text"
                    value={
                      this.state.sanzione.anagraficaTrasgressore.luogoDiNascita
                    }
                    onChange={this.changeTextSanzioneLuogoNascita.bind(this)}
                    disabled={this.state.disableInput}
                  ></input>
                </div>
              </div>
              <br></br>
              <fieldset className="border p-2">
                <legend className="w-auto" style={{ color: "#4e73df" }}>
                  Documento di riconoscimento
                </legend>
                <div className="row">
                  <div className="col-sm-2">N° doc.</div>
                  <div className="col-sm-4">
                    <input
                      className="form-control"
                      type="text"
                      maxLength="20"
                      value={
                        this.state.sanzione.anagraficaTrasgressore
                          .numeroDocumento
                      }
                      onChange={this.changeTextSanzioneNDoc.bind(this)}
                      disabled={this.state.disableInput}
                    ></input>
                  </div>
                  {this.state.testoModificaSanzione != "Abilita Modifiche" ? (
                    <>
                      {" "}
                      <div className="col-sm-2">data rilascio</div>
                      <div className="col-sm-4">
                        <input
                          className="form-control"
                          type="date"
                          value={
                            getFormatOraInput(this.state.sanzione.anagraficaTrasgressore
                              .dataRilascioDocumento)
                          }
                          placeholder="GG/MM/YYYY"
                          onChange={this.changeTextSanzioneDataDoc.bind(this)}
                          disabled={this.state.disableInput}
                        ></input>
                        {/* {this.state.errorDataDiRilascioTrasgessore ? (
                          <>
                            <small className="text-danger">
                              Il formato della data è GG/MM/YYYY
                            </small>
                          </>
                        ) : (
                          <></>
                        )} */}
                      </div>
                    </>
                  ) : (
                    <>
                      {" "}
                      <div className="col-sm-2">data rilascio</div>
                      <div className="col-sm-4">
                        <input
                          className="form-control"
                          type="text"
                          value={
                            this.state.sanzione.anagraficaTrasgressore
                              .dataRilascioDocumento
                          }
                          placeholder="GG/MM/YYYY"
                          onChange={this.changeTextSanzioneDataDoc.bind(this)}
                          disabled={this.state.disableInput}
                        ></input>
                        {/* {this.state.errorDataDiRilascioTrasgessore ? (
                          <>
                            <small className="text-danger">
                              Il formato della data è GG/MM/YYYY
                            </small>
                          </>
                        ) : (
                          <></>
                        )} */}
                      </div>
                    </>
                  )}
                </div>
                <br></br>
                <div className="row">
                  <div className="col-sm-2">rilasciato da</div>
                  <div className="col-sm-4">
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.sanzione.anagraficaTrasgressore
                          .enteRilascioDocumento
                      }
                      onChange={this.changeTextSanzioneEnteRilascioDoc.bind(
                        this
                      )}
                      disabled={this.state.disableInput}
                    ></input>
                  </div>
                  <div className="col-sm-2">tipo documento</div>
                  <div className="col-sm-4">
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.sanzione.anagraficaTrasgressore.tipoDocumento
                      }
                      onChange={this.changeTextTipoDocumento.bind(
                        this
                      )}
                      disabled={this.state.disableInput}
                    ></input>
                  </div>
                </div>
              </fieldset>
              <br></br>
              <fieldset className="border p-2">
                <legend className="w-auto" style={{ color: "#4e73df" }}>
                  Residenza
                </legend>
                <div className="row">
                  <div className="col-sm-2">
                    Comune {!this.state.sanzione.anagraficaTrasgressore.isMinorenne  && <small className="text-danger">*</small>}
                  </div>
                  <div className="col-sm-10">
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.sanzione.anagraficaTrasgressore
                          .comuneDiResidenza
                      }
                      onChange={this.changeTextSanzioneComuneResidenza.bind(
                        this
                      )}
                      disabled={this.state.disableInput}
                    ></input>
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-sm-2">
                    indirizzo {!this.state.sanzione.anagraficaTrasgressore.isMinorenne && <small className="text-danger">*</small>}
                  </div>
                  <div className="col-sm-10">
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.sanzione.anagraficaTrasgressore
                          .inidirizzoDiResidenza
                      }
                      onChange={this.changeTextSanzioneIndirizzoResidenza.bind(
                        this
                      )}
                      disabled={this.state.disableInput}
                    ></input>
                  </div>
                </div>
                <br></br>
                <div className="row">
                  <div className="col-sm-1">
                    n° {!this.state.sanzione.anagraficaTrasgressore.isMinorenne &&<small className="text-danger">*</small>}
                  </div>
                  <div className="col-sm-3">
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.sanzione.anagraficaTrasgressore
                          .inidirizzoNumeroDiResidenza
                      }
                      onChange={this.changeTextSanzioneNumIndirizzoResidenza.bind(
                        this
                      )}
                      disabled={this.state.disableInput}
                    ></input>
                  </div>
                  <div className="col-sm-1">
                    Cap
                  </div>
                  <div className="col-sm-2">
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.sanzione.anagraficaTrasgressore
                          .capDiResidenza
                      }
                      onChange={this.changeTextSanzioneCapResidenza.bind(this)}
                      disabled={this.state.disableInput}
                    ></input>
                  </div>
                  <div className="col-sm-2">
                    Provincia
                  </div>
                  <div className="col-sm-3">
                    <input
                      className="form-control"
                      type="text"
                      value={
                        this.state.sanzione.anagraficaTrasgressore
                          .provinciaDiResidenza
                      }
                      onChange={this.changeTextSanzionePRResidenza.bind(this)}
                      disabled={this.state.disableInput}
                    ></input>
                  </div>
                </div>
              </fieldset>
              <br></br>
            </fieldset>
            {this.showDatiAnagraficaPatriaPotesta()}
            <fieldset className="border p-2">
              <legend className="w-auto" style={{ color: "#4e73df" }}>
                Dettaglio Sanzione
              </legend>
              <br></br>
              <br></br>
              <br></br>
              <div className="row">
                <div className="col-sm-4">Località <small className="text-danger">*</small></div>
                <div className="col-sm-8">
                  <input
                    className="form-control"
                    type="text"
                    value={this.state.sanzione.localita}
                    onChange={this.changeTextSanzioneLocalita.bind(this)}
                    disabled={this.state.disableInput}
                  ></input>
                </div>
              </div>
              <br/>
              <div className="row">
                <div className="col-sm-4">Violazione</div>
                <div className="col-sm-8">
                  <input
                    className="form-control"
                    type="text"
                    value={
                      this.state.sanzione.anagraficaTipologiaSanzione
                        .nomeViolazione
                    }
                    onChange={(e) => this.setState({ text: e.target.value })}
                    disabled={this.state.disableInput}
                  ></input>
                </div>
              </div>
              <br></br>
              <div className="row">
                <div className="col-sm-4">Eventuale Nota Controllore</div>
                <div className="col-sm-8">
                  <textarea
                    className="form-control"
                    type="area"
                    value={this.state.sanzione.annotazioneControllore}
                    onChange={this.changeTextSanzioneAnnotazione.bind(this)}
                    disabled={this.state.disableInput}
                  ></textarea>
                </div>
              </div>
              <br></br>
              <div className="row">
                <div className="col-sm-4">Eventuale Nota Trasgressore</div>
                <div className="col-sm-8">
                  <textarea
                    className="form-control"
                    type="area"
                    value={this.state.sanzione.noteTrasgressore}
                    onChange={this.changeTextSanzioneAnnotazioneTrasgressore.bind(this)}
                    disabled={this.state.disableInput}
                  ></textarea>
                </div>
              </div>
            </fieldset>
            <br></br>
            {/* Bottoni */}
            {this.state.sanzione.anagraficaStati.nomeStato ===
            "Scritto Difensivo"
              ? this.showBottonScrittoDifensivo()
              : this.state.sanzione.anagraficaStati.nomeStato === "Bloccata"
              ? this.showSbloccaSanzione()
              : this.showButton()}
            <br />
            <br />
          </div>
        </div>

        <Modal show={this.state.showModalModificaSanzione}>
          <Modal.Header>
            <Modal.Title>Modifica Sanzione</Modal.Title>
          </Modal.Header>
          <Modal.Body>Sei sicuro di modificare la Sanzione?</Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.annullaModificaSanzione.bind(this)}
            >
              Annulla
            </Button>
            <Button
              variant="primary"
              onClick={this.confermaModificaSanzione.bind(this)}
            >
              {this.state.loadingButton ? <LoadSpinner/> : "Modifica Sanzione"}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.showModalScrittoDifensivoToValidata}>
          <Modal.Header>
            <Modal.Title>Cambio di stato Sanzione</Modal.Title>
          </Modal.Header>
          <Modal.Body>Sei sicuro di voler spostare in sanzioni stato validato ?</Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.annullaSpostaValidata.bind(this)}
            >
              Annulla
            </Button>
            <Button
              variant="primary"
              // disabled={this.state.buttonConfermaValidaznione}
              onClick={this.confermaSpostaValidata.bind(this)}
            >
              Sposta
            </Button>
          </Modal.Footer>
        </Modal>


        <Modal size="xl" show={this.state.showModalAvanzaStato}>
          <Modal.Header>
            <Modal.Title>Valida Sanzione</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Sei sicuro di validare la Sanzione? */}
            {this.superFraseDaCambiare}
            <br></br>
            <p className="text-center">{/* {this.superFraseDaCambiare} */}</p>
            <br></br>
            {this.state.validaInidirizzo.esito ? (
              this.state.validaInidirizzo.esito === "KO" ? (
                <>
                  {/* <div class="card-body text-center">
                  <h5 class="card-title">
                    {this.state.validaInidirizzo.messaggio}
                  </h5>
                </div> */}
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">Indirizzo trovato sui server</th>
                        {/* <th className="text-center" scope="col">
                        Esito
                      </th> */}
                        <th scope="col">Messaggio</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="table-danger">
                        <td>
                          {this.state.validaInidirizzo.viaResponse},{" "}
                          {this.state.validaInidirizzo.numeroResponse},{" "}
                          {this.state.validaInidirizzo.comuneResponse} (
                          {this.state.validaInidirizzo.provinciaResponse}),{" "}
                          {this.state.validaInidirizzo.capResponse}
                        </td>
                        {/* <td className="text-center">
                        {this.state.validaInidirizzo.esito.replace("_", " ")}
                      </td> */}
                        <td className="">
                          <ul>
                            {this.state.messaggioList.map((Frase) => {
                              if (Frase) {
                                return (
                                  <>
                                    <li>{Frase}</li>
                                  </>
                                );
                              } else {
                                return <></>;
                              }
                            })}
                          </ul>
                          {/* {this.state.validaInidirizzo.messaggio} */}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </>
              ) : this.state.validaInidirizzo.esito === "KO_PARZIALE" ? (
                <>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">Indirizzo trovato sui server</th>
                        {/* <th  className="text-center"scope="col">Esito</th> */}
                        <th className="text-center" scope="col">
                          Messaggio
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="table-warning">
                        <td>
                          {this.state.validaInidirizzo.viaResponse},{" "}
                          {this.state.validaInidirizzo.numeroResponse},{" "}
                          {this.state.validaInidirizzo.comuneResponse} (
                          {this.state.validaInidirizzo.provinciaResponse}),{" "}
                          {this.state.validaInidirizzo.capResponse}
                        </td>
                        {/* <td className="text-center">{this.state.validaInidirizzo.esito}</td> */}
                        {/* {this.state.validaInidirizzo.messaggio ===
                      "Civico non trovato" ? (
                        <td className="text-center">
                          {this.state.validaInidirizzo.messaggio}
                        </td>
) : (
)} */}

                        <td>
                          <ul>
                            {this.state.messaggioList.map((Frase) => {
                              if (Frase) {
                                return (
                                  <>
                                    <li>{Frase}</li>
                                  </>
                                );
                              } else {
                                return <></>;
                              }
                            })}
                          </ul>
                        </td>

                        {/* <td>{this.state.validaInidirizzo.messaggio}</td> */}
                      </tr>
                    </tbody>
                  </table>
                </>
              ) : (
                <>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">Indirizzo trovato sui server</th>
                        {/* <th className="text-center" scope="col">Esito</th> */}
                        <th className="text-center" scope="col">
                          Messaggio
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="">
                        <td>
                          {this.state.validaInidirizzo.viaResponse},{" "}
                          {this.state.validaInidirizzo.numeroResponse},{" "}
                          {this.state.validaInidirizzo.comuneResponse} (
                          {this.state.validaInidirizzo.provinciaResponse}),{" "}
                          {this.state.validaInidirizzo.capResponse}
                        </td>
                        {/* <td className="text-center">{this.state.validaInidirizzo.esito.replace("_", " ")}</td> */}
                        <td className="">
                          <ul>
                            {this.state.messaggioList.map((Frase) => {
                              if (Frase) {
                                return (
                                  <>
                                    <li>{Frase}</li>
                                  </>
                                );
                              } else {
                                return <></>;
                              }
                            })}
                          </ul>
                          {/* {this.state.validaInidirizzo.messaggio} */}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </>
              )
            ) : (
              <h5>
                I nostri server non sono rangiungibili per validare l'indirizzo
              </h5>
            )}

            {/* <div className="text-center">
            <button className="btn btn-success" onClick={()=>{
              toast.success("Ora puoi validare la saznione")
              this.setState({buttonConfermaValidaznione:false})
            }}>Conferma</button>&nbsp;<button className="btn btn-secondary" onClick={()=>{
              toast.warning("Cambia l'indirizzo")
              this.setState({showModalAvanzaStato:false})
            }}>Annualla</button>
            </div> */}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.annullaCambioStato.bind(this)}
            >
              Annulla
            </Button>
            <Button
              variant="primary"
              // disabled={this.state.buttonConfermaValidaznione}
              onClick={this.confermaCambioStato.bind(this)}
            >
              Valida Sanzione
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.showModalChiudiSanzione}>
          <Modal.Header>
            <Modal.Title>Altre Azioni</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                Scegli Stato
                <Form.Control
                  as="select"
                  onChange={this.changeSelectStatoAltriStati.bind(this)}
                >
                  <option value={0}>Scegli altri Stati</option>
                  {this.state.listaStatiTo.map((Valore) => {
                    if (Valore.nomeStato === "Annullata") {
                      // return <option id={Valore.idStato} value="Annullata">Annulla Sanzione</option>
                      return (
                        <option id={Valore.idStato} value={Valore.idStato}>
                          Annulla Sanzione
                        </option>
                      );
                    }
                    if (Valore.nomeStato === "Bloccata") {
                      // return <option  id={Valore.idStato} value="Bloccata">Blocca Sanzione</option>
                      return (
                        <option id={Valore.idStato} value={Valore.idStato}>
                          Blocca Sanzione
                        </option>
                      );
                    }
                    if (Valore.nomeStato === "Agli Atti") {
                      // return <option  id={Valore.idStato} value="Agli Atti">Agli Atti</option>
                      return (
                        <option id={Valore.idStato} value={Valore.idStato}>
                          Agli Atti
                        </option>
                      );
                    }
                  })}
                </Form.Control>
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                Note
                <textarea
                  className="form-control"
                  type="area"
                  placeholder="eventuali note"
                  value={this.state.noteAltriStati}
                  onChange={this.changeTextnoteAltriStati.bind(this)}
                ></textarea>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.annullaAltriStati.bind(this)}
            >
              Annulla
            </Button>
            <Button
              variant="primary"
              onClick={this.confermaAltriStati.bind(this)}
              disabled={!(this.state.noteAltriStati.length >= 5 && this.state.selectAltriStati !== 0)}
            >
              Esegui
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.showModalInvioMail}>
          <Modal.Header>
            <Modal.Title>Invio Mail Sanzione</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            inserisci la mail del destinatario
            <input
              className="form-control"
              type="text"
              value={this.state.fieldIndirizzoMail}
              onChange={this.changeTextIndirizzoInvioMail.bind(this)}
            ></input>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.annullaInviaMail.bind(this)}
            >
              Annulla
            </Button>
            <Button
              variant="primary"
              disabled={this.state.isErrorEmail}
              onClick={this.confermaInviaMail.bind(this)}
            >
              Invia Mail
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal size="lg"  show={this.state.showModalStoricoSanzione}>
          <Modal.Header>
            <Modal.Title>Storico Sanzione</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{ maxHeight: "calc(100vh - 210px)", overflowY: "auto" }}
          >
              <ul className="events w-auto p-3">
                {this.renderAllStoricoStatiSanzione()}
              </ul>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.chiudiStoricoSanzione.bind(this)}
            >
              Chiudi
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.showModalPaga}>
          <Modal.Header>
            <Modal.Title>
              {this.state.statoSingolaRata === "daPagare"
                ? "Paga Rata"
                : this.state.statoSingolaRata === "pagata"
                ? "Rata Pagata"
                : "Paga Sanzione"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.statoSingolaRata === "pagata" ? (
              <>
                <Col>
                  Data Contabile
                  <input
                    className="form-control"
                    type="text  "
                    disabled={true}
                    //placeholder="GG/MM/YYYY"
                    value={new Date(
                      this.state.paga.dataContabile
                    ).toLocaleDateString(undefined, {
                      year: "numeric",
                      month: "numeric",
                      day: "numeric",
                    })}
                    onChange={this.changeTextDataContabile.bind(this)}
                  ></input>
                </Col>
                <Col>
                  Tipo Pagamento
                  <input
                    className="form-control"
                    type="text  "
                    disabled={true}
                    value={this.state.paga.tipoPagamento}
                  ></input>
                  {/* <Form.Control as="select" disabled={true}> */}
                  {/* <option>Select Tipo Pagamento</option> */}
                  {/* <option value="1">Iban</option> */}
                  {/* <option value="2">Conto Postale</option> */}
                  {/* <option value="3">Contanti</option> */}
                  {/* <option value={this.state.paga.tipoPagamento}>{this.state.paga.tipoPagamento}</option> */}
                  {/* </Form.Control> */}
                </Col>
                <Col>
                  Importo Netto
                  <div className="input-group mb-3">
                    <div className="input-group-prepend">
                      <span className="input-group-text">€</span>
                    </div>
                    <input
                      disabled={true}
                      className="form-control"
                      type="text"
                      placeholder="Importo"
                      value={parseFloat(
                        this.state.paga.importoNetto / 100
                      ).toFixed(2)}
                      onChange={this.changeTextImportoNetto.bind(this)}
                    ></input>
                  </div>
                </Col>
                <Col>
                  Codice Transazione
                  <input
                    disabled={true}
                    className="form-control"
                    type="text"
                    placeholder="identificativo transazione"
                    value={this.state.paga.codiceTx}
                    onChange={this.changeTextCodiceTransazione.bind(this)}
                  ></input>
                </Col>
                <Row>
                  <Col>
                    Note
                    <textarea
                      className="form-control"
                      type="area"
                      disabled={true}
                      placeholder="eventuali note"
                      value={this.state.paga.note}
                      onChange={this.changeTextEventualiNotePagamento.bind(
                        this
                      )}
                      // disabled={this.state.disableInput}
                    ></textarea>
                  </Col>
                </Row>
              </>
            ) : this.state.statoSingolaRata === "daPagare" ? (
              <>
                <Col>
                  Data Contabile
                  <input
                    className="form-control"
                    type="date"
                    disabled={this.state.bloccoTastiAlconfermaPagamento}
                    placeholder="GG/MM/YYYY"
                    value={this.state.paga.dataContabile}
                    onChange={this.changeTextDataContabile.bind(this)}
                  ></input>
                </Col>
                <Col>
                  Tipo Pagamento
                  <Form.Control
                    as="select"
                    disabled={this.state.bloccoTastiAlconfermaPagamento}
                    onChange={this.changeTextTipoPagamento.bind(this)}
                  >
                    <option>Tipo Pagamento</option>
                    <option value="Iban">Iban</option>
                    <option value="Conto Postale">Conto Postale</option>
                    <option value="Contanti">Contanti</option>
                    <option value="Pos">Pos</option>
                  </Form.Control>
                </Col>
                <Col>
                  Importo Netto
                  <div className="input-group mb-3">
                    <div className="input-group-prepend">
                      <span className="input-group-text">€</span>
                    </div>

                    <input
                      className="form-control"
                      type="text"
                      placeholder="Importo"
                      // value={this.state.paga.importoNetto}
                      disabled={this.state.bloccoTastiAlconfermaPagamento}
                      value={this.state.paga.importoNetto}
                      onChange={this.changeTextImportoNetto.bind(this)}
                    ></input>
                  </div>
                </Col>
                <Col>
                  Codice Transazione
                  <input
                    className="form-control"
                    type="text"
                    placeholder="identificativo transazione"
                    value={this.state.paga.codiceTx}
                    disabled={this.state.bloccoTastiAlconfermaPagamento}
                    onChange={this.changeTextCodiceTransazione.bind(this)}
                  ></input>
                </Col>
                <Row>
                  <Col>
                    Note
                    <textarea
                      className="form-control"
                      type="area"
                      placeholder="eventuali note"
                      value={this.state.paga.note}
                      disabled={this.state.bloccoTastiAlconfermaPagamento}
                      onChange={this.changeTextEventualiNotePagamento.bind(
                        this
                      )}
                      // disabled={this.state.disableInput}
                    ></textarea>
                  </Col>
                </Row>
              </>
            ) : (
              <>
                <Col>
                  Data Contabile
                  <input
                    className="form-control"
                    type="date"
                    placeholder="GG/MM/YYYY"
                    value={this.state.paga.dataContabile}
                    disabled={this.state.bloccoTastiAlconfermaPagamento}
                    onChange={this.changeTextDataContabile.bind(this)}
                  ></input>
                </Col>
                <Col>
                  Tipo Pagamento
                  <Form.Control
                    as="select"
                    onChange={this.changeTextTipoPagamento.bind(this)}
                    disabled={this.state.bloccoTastiAlconfermaPagamento}
                  >
                    <option value="0">Tipo Pagamento</option>
                    <option value="1">Iban</option>
                    <option value="2">Conto Postale</option>
                    <option value="3">Contanti</option>
                    <option value="4">Pos</option>
                  </Form.Control>
                </Col>
                <Col>
                  Importo Netto
                  <div className="input-group mb-3">
                    <div className="input-group-prepend">
                      <span className="input-group-text">€</span>
                    </div>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Importo"
                      value={this.state.paga.importoNetto}
                      disabled={this.state.bloccoTastiAlconfermaPagamento}
                      onChange={this.changeTextImportoNetto.bind(this)}
                    ></input>
                  </div>
                </Col>
                <Col>
                  Codice Transazione
                  <input
                    className="form-control"
                    type="text"
                    placeholder="identificativo transazione"
                    value={this.state.paga.codiceTx}
                    disabled={this.state.bloccoTastiAlconfermaPagamento}
                    onChange={this.changeTextCodiceTransazione.bind(this)}
                  ></input>
                </Col>
                <Row>
                  <Col>
                    Note
                    <textarea
                      className="form-control"
                      type="area"
                      placeholder="eventuali note"
                      value={this.state.paga.note}
                      disabled={this.state.bloccoTastiAlconfermaPagamento}
                      onChange={this.changeTextNotaPagaSanzione.bind(this)}
                      // disabled={this.state.disableInput}
                    ></textarea>
                  </Col>
                </Row>
              </>
            )}
            <br></br>
            {this.state.confermaUlteriorreDiunPagamento === true ? (
              ""
            ) : (
              <div className="text-center">
                <h4>
                  Confermi di voler Pagare :{" "}
                  €{" "}{this.state.paga.importoNetto}
                </h4>
                <h4 className="text-danger">
                  Attenzione, non è un ravvedimento operoso
                </h4>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            {this.state.statoSingolaRata === "pagata" ? (
              <>
                <Button
                  variant="secondary"
                  onClick={this.annullaPaga.bind(this)}
                >
                  Chiudi Scheda
                </Button>
              </>
            ) : this.state.confermaUlteriorreDiunPagamento === true ? (
              <>
                <Button
                  variant="secondary"
                  onClick={this.annullaPaga.bind(this)}
                >
                  Annulla
                </Button>
                <Button
                  variant="primary"
                  // disabled={
                  //   this.state.importoInferiroDellaSanzioneDiUnPagamento
                  // }
                  disabled={!(this.state.paga.codiceTx &&
                    this.state.paga.dataContabile &&
                    this.state.paga.tipoPagamento !== "0" &&
                    !this.state.loadingButton &&
                    this.checkImportoDaPagare()
                  )}
                  onClick={() => {
                    this.setState({
                      confermaUlteriorreDiunPagamento: false,
                      bloccoTastiAlconfermaPagamento: true,
                    });
                  }}
                >
                  {this.state.loadingButton ? <LoadSpinner/> : "Paga"}
                </Button>{" "}
              </>
            ) : this.state.statoSingolaRata === "daPagare" ? (
              <>
                <Button
                  variant="secondary"
                  onClick={this.annullaPaga.bind(this)}
                >
                  Annulla
                </Button>
                <Button
                  variant="primary"
                  onClick={this.confermaPaga.bind(this)}
                >
                  Conferma Paga Rata
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="secondary"
                  onClick={this.annullaPaga.bind(this)}
                >
                  Annulla
                </Button>
                <Button
                  variant="primary"
                  onClick={this.confermaPaga.bind(this)}
                >
                  Conferma Paga Sanzione
                </Button>
              </>
            )}
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.showModalRavvedimentoOperoso}>
          <Modal.Header>
            <Modal.Title>Ravvedimento Operoso Sanzione</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col>
                Nuovo Importo Sanzione
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text">€</span>
                  </div>
                  <input
                    type="text"
                    value={this.state.nuovoImportoRavvedimentoOperoso}
                    onChange={this.changeTextImportoRavvedimentoOperoso.bind(
                      this
                    )}
                    className="form-control"
                    aria-label="Importo in euro"
                  />
                </div>
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                Note
                <textarea
                  className="form-control"
                  type="area"
                  placeholder="eventuali note (minimo 5 caratteri)"
                  value={this.state.notaRavvedimentoOperoso}
                  onChange={this.changeTextNotaRavvedimentoOperoso.bind(this)}
                ></textarea>
              </Col>
            </Row>
            <br />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.annullaRavvedimentoOperoso.bind(this)}
            >
              Annulla
            </Button>
            <Button
              variant="primary"
              disabled={this.state.isNotaRavvedimentoOperoso || !this.ravvedimentoOperosoValueRegex.test(this.state.nuovoImportoRavvedimentoOperoso) }
              onClick={this.confermaRavvedimentoOperoso.bind(this)}
            >
              {this.state.loadingButton ? <LoadSpinner/> : "Esegui"}
            </Button>
          </Modal.Footer>
        </Modal>
        {this.modalScrittoDifensivo()}
        {this.modalSbloccaSanzione()}
        {this.modalRateizzaSanzione()}
        {this.modalRateDaPagare()}
        {this.modalAgliAttiScrittoDifensivo()}
        {this.tabbellaSanzioniRecidivo()}
        {this.modalAttoIngiuntivo()}
        {this.modalConfermaAnnullaTentativoPagamento()}
        {this.modalConfermaEliminaAllegato()}
        {this.modalStoricoPagamenti()}
      </div>
    );

    return <div>{content}</div>;
  }
}
export default withRouter(DetailSanzione);
